/* eslint-disable no-use-before-define */
/* eslint-disable no-promise-executor-return */
import React, { createRef, useState, useRef, useEffect, useCallback, useReducer } from "react";
import {
	ClientService,
	ContactService,
	InvoiceService,
	PaymentService,
	JurisdictionFeeService,
	GenericService,
	TimecardService,
	NonRKPayInvoiceEstimatesService,
	NonRKPayInvoiceService,
} from "@services";
import { isEqual } from "@utils/lodash";
import utils from "@utils";
import {
	NON_RK_PAY_FEE_TYPES,
	NONRKPAY_INVOICE_ESTIMATES_INVOICEABLE_ERROR_CODES,
	V3_INVOICE_TYPE_ID
} from "@constants";
import {
	builNonRKPayInvoiceInitialState,
	nonRKPayInvoiceRecuder,
	NONRKPAYINVOICE_ACTIONS,
} from "./nonRKPayInvoiceReducer";

const useNonRKPayInvoiceDetailHook = props => {
	const { lang } = global;
	const {
		user,
		user: {
			TimeZoneId,
			Organization: { NonRKPayInvoicingEnabled },
			Features,
		},
		flags: {
			timecardAttachmentsInvoiceV4,
			editTimecardAgencyInvoice,
			newNonrkpayPrepayFlow,
			timeCardNotesModalEnabled,
			nonrkpayDetailPrepayEnhancements,
			allowVoidNonrkpayInvoicesV2,
			revertInvoiceToPendingAgencyReview,
			useStrictValidationForInvoiceClientEmail,
			regenerateEstimateItemsEnabled
		},
		router,
		location: { query },
		route,
	} = props;

	const timecardAttachmentsInvoiceV4Enabled = !!timecardAttachmentsInvoiceV4;
	const editTimecardAgencyInvoiceEnabled = !!editTimecardAgencyInvoice;
	const isTimeCardNotesModalEnabled = !!timeCardNotesModalEnabled;
	const nonrkpayDetailPrepayEnhancementsEnabled = !!nonrkpayDetailPrepayEnhancements;
	const newNonrkpayPrepayFlowEnabled = !!newNonrkpayPrepayFlow;
	const allowVoidNonrkpayInvoicesV2Enabled = !!allowVoidNonrkpayInvoicesV2;
	const revertInvoiceToPendingAgencyReviewEnabled = !!revertInvoiceToPendingAgencyReview;
	const useStrictValidationForInvoiceClientEmailEnabled = !!useStrictValidationForInvoiceClientEmail;
	const isRegenerateEstimateItemsEnabled = !!regenerateEstimateItemsEnabled;

	const invoiceInitialState = builNonRKPayInvoiceInitialState(TimeZoneId);

	const [invoiceState, dispatchInvoice] = useReducer(nonRKPayInvoiceRecuder, invoiceInitialState);

	const [originalInvoice, setOriginalInvoice] = useState(undefined);
	const [selectedClient, setSelectedClient] = useState({
		value: "",
		label: "",
	});
	const [customFee, setCustomFee] = useState({
		Name: "",
		Total: "",
		nameError: false,
		totalError: false,
	});
	const [lineItemUpdates, setLineItemUpdates] = useState([]);
	const [paymentHistory, setPaymentHistory] = useState([]);
	const [refundsInTransit, setRefundsInTransit] = useState([]);
	const [availableFunds, setAvailableFunds] = useState(0);

	const [isInvoicingV3, setIsInvoicingV3] = useState(false);
	const [deletingOfficerViewJob, setDeletingOfficerViewJob] = useState(undefined);
	const [invoiceConflicts, setInvoiceConflicts] = useState([]);
	const [feeTypes, setFeeTypes] = useState([]);
	const [vehicleTypes, setVehicleTypes] = useState([]);
	const [agencyFeePresets, setAgencyFeePresets] = useState({});

	const [excludeOfficerRate, setExcludeOfficerRate] = useState(false);

	const [selectedAttachment, setSelectedAttachment] = useState({});
	const [selectedNote, setSelectedNote] = useState({});
	const [attachments, setAttachments] = useState(0);

	const [notes, setNotes] = useState(0);
	const [internalNotes, setInternalNotes] = useState("");
	const [shouldPreventReinitialization, setShouldPreventReinitialization] = useState(true);

	// Lists
	const [clientList, setClientList] = useState({
		loading: true,
		data: [],
	});

	const [associatedInvoices, setAssociatedInvoices] = useState([]);

	const [currentTimeCardItem, setCurrentTimeCardItem] = useState(undefined);
	const [jobActivityLogModalLineItem, setJobActivityLogModalLineItem] = useState(undefined);

	// Modals
	const [missingTimecardModal, setMissingTimecardModal] = useState(undefined);
	const [showConvertEstimateModal, setShowConvertEstimateModal] = useState(false);
	const [showUpdateLineItemsModal, setShowUpdateLineItemsModal] = useState(false);
	const [emailInvoiceModal, setEmailInvoiceModal] = useState({ show: false });
	const [showAttachmentsModal, setShowAttachmentsModal] = useState(false);
	const [showTimeCardNotesModal, setShowTimeCardNotesModal] = useState(false);
	const [showPaymentHistory, setShowPaymentHistory] = useState(false);
	const [showInternalNotes, setShowInternalNotes] = useState(false);
	const [showInternalNotesModal, setShowInternalNotesModal] = useState(false);
	const [showEditTimeCardForm, setShowEditTimeCardForm] = useState(false);
	const [showJobActivityLogModal, setShowJobActivityLogModal] = useState(false);
	const [showRefundNonRKPayInvoiceEstimateModal, setShowRefundNonRKPayInvoiceEstimateModal] =
		useState(false);
	const [showGenerateEstimateInvoiceModal, setShowGenerateEstimateInvoiceModal] = useState(false);
	const [showConnectedInvoicesModal, setShowConnectedInvoicesModal] = useState(false);

	// Loadings
	const [loadingLineItems, setLoadingLineItems] = useState(false);
	const [loadingInvoiceTotals, setLoadingInvoiceTotals] = useState(false);
	const [downloadingInvoice, setDownloadingInvoice] = useState(false);
	const [savingInvoice, setSavingInvoice] = useState(false);
	const [refundingInvoice, setRefundingInvoice] = useState(false);
	const [loadingInvoice, setLoadingInvoice] = useState(false);
	const [verifyingEstimateInvoiceable, setVerifyingEstimateInvoiceable] = useState(false);
	const [finalizingEstimate, setFinalizingEstimate] = useState(false);
	const [generatingInvoiceFromEstimate, setGeneratingInvoiceFromEstimate] = useState(false);
	const [loadingEstimateAssociatedInvoices, setLoadingEstimateAssociatedInvoices] =
		useState(false);

	const [confirmedExit, setConfirmedExit] = useState(false);
	// State added since when user discard unsaved changes, the router.push action has to be
	// triggered inside the useEffect and not directly in the event handler
	// without this state, we don't know where the user was trying to go
	const [pathnameToGo, setPathnameToGo] = useState("");

	const [forceShowConvertEstimateModal, setForceShowConvertEstimateModal] = useState(false);
	const [forceFetchInvoiceDraftTotals, setForceFetchInvoiceDraftTotals] = useState(false);
	const [forceCheckExcludeOfficerRate, setForceCheckExcludeOfficerRate] = useState(false);
	const [convertingEstimateToInvoice, setConvertingEstimateToInvoice] = useState(false);
	const [forceApplyPaymentModal, setForceApplyPaymentModal] = useState({
		show: false,
		invoiceId: null,
	});

	const [newLineItemsToAdd, setNewLineItemsToAdd] = useState([]);
	const [initialInvoiceLoadFinished, setInitialInvoiceLoadFinished] = useState(false);
	const [addingLineItemsFromUri, setAddingLineItemsFromUri] = useState(false);
	const [initialized, setInitialized] = useState(false);

	const confirmationModal = useRef();
	const addJobsModal = createRef();
	const applyPaymentsModal = createRef();

	const fetchInternalNotesForNonRKPayInvoice = async invoiceId => {
		try {
			const { data } = await InvoiceService.getInternalNotesForNonRKPayInvoice(invoiceId);
			return data;
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error getting invoice internal notes_"),
				title: "Error",
			});
			return null;
		}
	};

	const fetchNonRKPayLineItemsForJobs = async (workedJobs, jobIds) => {
		try {
			setLoadingLineItems(true);
			const { data } = await InvoiceService.getNonRKPayLineItems(workedJobs, jobIds);
			return data;
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error retrieving line items"),
				timeOut: 2000,
			});
			return null;
		} finally {
			setLoadingLineItems(false);
		}
	};

	const fetchPayments = async invoiceId => {
		try {
			const { data } = await PaymentService.getNonRKPayInvoicePayments(invoiceId);
			return data;
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error getting payment history"),
				title: lang.t("Error"),
			});
			return null;
		}
	};

	const fetchRefundsInTransit = async invoiceId => {
		try {
			const { data } = await PaymentService.getNonRKPayInvoiceRefundsInTransit(invoiceId);
			return data;
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error getting refunds in transit"),
				title: lang.t("Error"),
			});
			return null;
		}
	};

	const finalizeEstimate = async estimateId => {
		try {
			setFinalizingEstimate(true);
			const { data } = await NonRKPayInvoiceEstimatesService.finalizeEstimate(estimateId);
			return data;
		} catch ({ response, response: { data } }) {
			utils.notify({
				type: "error",
				message: data?.Message ?? lang.t("Error finalizing estimate"),
				title: lang.t("Error"),
			});

			return null;
		} finally {
			setFinalizingEstimate(false);
		}
	};

	const generateInvoiceFromEstimate = async (id, dueDate) => {
		try {
			setGeneratingInvoiceFromEstimate(true);
			const { data } = await NonRKPayInvoiceEstimatesService.generateInvoiceFromEstimate({
				id,
				dueDate,
			});
			return data;
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error generating invoice"),
				title: lang.t("Error"),
			});
			return null;
		} finally {
			setGeneratingInvoiceFromEstimate(false);
		}
	};

	const reGenerateInvoiceItems = async (jobIds) => {
		try {
			const { data } = await InvoiceService.getNonRKPayLineItems(true, jobIds);
			return data;
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error applying job updates to invoice"),
				title: lang.t("Error"),
			});
			return null;
		}
	};

	const reGenerateEstimateItems = async (estimateId) => {
		try {
			const { data } = await NonRKPayInvoiceEstimatesService.regenerateEstimateItems(estimateId);

			// We need to perform some parsing becasue of the Nexus client.
			// OfficerId if not provided Nexus client will parse it to undefined
			// JobStartTime parsed since Nexus client creates a new Date object with the local timezone
			const dataParsed = data.map((item) => ({
				...item,
				JobStartTime: utils.buildUtcStringFromLocalParsedDate(item.JobStartTime),
				JobEndTime: utils.buildUtcStringFromLocalParsedDate(item.JobEndTime),
				OfficerId: item.OfficerId || null,
				PONumber: item.PoNumber,
			}));

			return dataParsed;
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error applying job updates to estimate"),
				title: lang.t("Error"),
			});
			return null;
		}
	};

	/**
	 * Retrieves all details specific to an invioce
	 * @param {Number} id The uniqe id of an invoice
	 */
	const getInvoiceDetails = async id => {
		try {
			setLoadingInvoice(true);
			const { data } = await InvoiceService.getNonRKPayInvoice(id);
			return data;
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error loading invoice details"),
				timeOut: 2000,
			});
			return returnToList();
		} finally {
			setLoadingInvoice(false);
		}
	};

	/**
	 * Retrieves a list of clients that can be associated with the invoice
	 * @param {String} isEstimate Determines the type of invoice being displayed
	 */
	const getClients = async isEstimate => {
		const { finalized } = invoiceState;
		const {
			Organization: { Id: organizationId },
		} = user;

		try {
			const { data } = await ClientService.getAll({
				organizationId,
				includeInactive: false,
				jobStatusFilter: isEstimate || (query.id && !finalized) ? 0 : 2,
			});
			return data;
		} catch (error) {
			setClientList({ loading: false });
			utils.notify({
				type: "error",
				message: lang.t("Error loading clients"),
				timeOut: 1500,
			});
			return null;
		}
	};

	/**
	 * Retrieves the billing contact for the invoice
	 * @param {Number} contactId The uniqe id of the billing contact
	 */
	const getBillingContact = async contactId => {
		try {
			const { data } = await ContactService.getContact(contactId);
			return data;
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error retrieving billing contact details"),
				timeOut: 2000,
			});
			return null;
		}
	};

	const getNonRKPayInvoiceDraftTotals = async () => {
		const {
			Organization: { NonRKPayPaymentsEnabled },
		} = user;
		const {
			invoiceVersion,
			lineItems,
			totals: { additionalFees },
		} = invoiceState;

		let version = invoiceVersion;

		if (!version) {
			version = NonRKPayPaymentsEnabled ? 3 : 2;
		}

		let clientId = selectedClient?.value;

		if (query.clientId) {
			clientId = query.clientId;
		}

		if (!clientId) {
			utils.notify({
				type: "error",
				message: lang.t("A client have to be selected"),
				timeOut: 2000,
			});
			return null;
		}

		const invoiceFees = additionalFees.map((invoiceFee, index) => ({
			...invoiceFee,
			Index: index,
		}));

		if (hasInValidAndMarkFeeRates(lineItems)) return null;

		const invoiceDraftRequest = {
			Fees: invoiceFees,
			Items: mapLineItemsToDraftItems(lineItems),
			ClientId: clientId,
			Version: version,
		};

		try {
			setLoadingInvoiceTotals(true);
			const { data } =
				await InvoiceService.getNonRKPayInvoiceDraftTotals(invoiceDraftRequest);
			return data;
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error loading invoice totals"),
				timeOut: 2000,
			});
			return null;
		} finally {
			setLoadingInvoiceTotals(false);
		}
	};

	const hasInValidAndMarkFeeRates = lineItems => {
		const { lineFeeToggler } = invoiceState;
		const hasNegativeRate = lineItems.some(item => item.Fees.some(({ Rate }) => Rate <= 0));
		if (hasNegativeRate) {
			const updatedLineItems = lineItems.map(item => {
				let updateLineFeeToggler = false;
				const updatedFees = item.Fees.map(fee => {
					if (fee.Rate <= 0) {
						updateLineFeeToggler = true;
						return {
							...fee,
							totalError: true,
						};
					}
					return fee;
				});
				if (updateLineFeeToggler) {
					lineFeeToggler[item.JobAssignmentId] = true;
				}
				return {
					...item,
					Fees: updatedFees,
				};
			});
			dispatchInvoice({
				type: NONRKPAYINVOICE_ACTIONS.SET_LINE_ITEMS,
				payload: updatedLineItems,
			});
		}

		return hasNegativeRate;
	};

	const refundInvoice = async invoiceId => {
		try {
			setRefundingInvoice(true);
			const { data } = await InvoiceService.refundBalance(invoiceId);
			if (data.RefundError !== null && data.RefundError.length > 0) {
				utils.notify({
					type: "error",
					message: lang.t("Error initiating refund"),
					timeOut: 1500,
				});
				return null;
			}
			utils.notify({
				type: "success",
				message: lang.t("Refund initiated"),
				timeOut: 2000,
			});
			return data;
		} catch (error) {
			if (error.response?.status === 400 && error.response?.data?.ErrorCode === 4) {
				confirmationModal.current.openModal({
					title: lang.t("Error initiating refund"),
					message: lang.t(
						"Pending payments must be fully processed before issuing refund",
					),
					confirmButton: lang.t("OK"),
				});
			} else {
				utils.notify({
					type: "error",
					message: lang.t(
						error.response?.data?.ErrorMessage || "Error initiating refund",
					),
					timeOut: 1500,
				});
			}
			return null;
		} finally {
			setRefundingInvoice(false);
		}
	};

	const voidInvoice = async (invoiceId, isEstimate) => {
		try {
			await InvoiceService.voidEstimate(invoiceId);
			return true;
		} catch (error) {
			utils.notify({
				type: "error",
				message: `${lang.t("Error voiding")} ${lang.t(isEstimate ? "Estimate" : "Invoice").toLowerCase()}`,
				timeOut: 1500,
			});
			return null;
		}
	};

	const addNewLineItem = (data, workedJobs) => {
		const areThereTimecardMissed = data.some(({ TimeCard }) => TimeCard === null);
		if (workedJobs && areThereTimecardMissed) {
			setMissingTimecardModal({ show: true, items: data });
		} else {
			const sorted = { existing: [], new: [] };
			data.forEach(item => {
				if (item.invoiceNumber) sorted.existing.push(item);
				else sorted.new.push(item);
			});
			// Display existing estimates in modal
			setInvoiceConflicts(sorted.existing);
			setLineItemsData(sorted.new);
		}
	};

	const setPaymentData = (data = []) => {
		const { rawApplied, rawPayments, rawRefunds } = data.reduce(
			(acc, { Amount = 0 }) => {
				acc.rawApplied += Amount;
				if (Amount > 0) acc.rawPayments += Amount;
				if (Amount < 0) acc.rawRefunds += Amount;
				return acc;
			},
			{ rawApplied: 0, rawPayments: 0, rawRefunds: 0 },
		);

		const appliedPayments = utils.bankersRound(rawApplied, 2);
		const payments = utils.bankersRound(rawPayments, 2);
		const refunds = utils.bankersRound(rawRefunds, 2);

		setPaymentHistory(data);
		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_PAYMENT_DATA,
			payload: { appliedPayments, payments, refunds },
		});
	};

	const setClientsData = async (data, isEstimate) => {
		const items = data.map(({ Id, Name, BillingContactId, EnforceV2NonRKPayInvoicing }) => ({
			value: Id,
			label: Name,
			BillingContactId,
			EnforceV2NonRKPayInvoicing
		}));

		let clientToSet;
		if (query.clientId) {
			clientToSet = items.find(client => client.value.toString() === query.clientId);
			if (clientToSet?.BillingContactId) {
				const billingContactData = await getBillingContact(clientToSet.BillingContactId);
				if (billingContactData)
					dispatchInvoice({
						type: NONRKPAYINVOICE_ACTIONS.SET_BILLING_CONTACT,
						payload: billingContactData,
					});
			}
		}
		setClientList({ loading: false, data: items });

		if (clientToSet) {
			setSelectedClient(clientToSet);
			const isOrganizationV3 = Features.some(f => f.toLowerCase() === "invoicingv3")

			if (isOrganizationV3 && isEstimate && !query.id) {
				const enforcesV2 = clientToSet?.EnforceV2NonRKPayInvoicing;
				if (enforcesV2) {
					dispatchInvoice({
					type: NONRKPAYINVOICE_ACTIONS.SET_INVOICE_PROPERTY_DATA,
					payload: { property: "prePay", value: false },
				});
				}
			}
		}

		determineInvoiceDisclaimer(false, clientToSet);
	};

	// For estimates, JobAssignmentId is null since there is no position-officer correllation.
	// Check for these cases and assign it a value so that we don't end up with multiple JobAssignmentIds of 'undefined'
	// Check for officer name when working on an estimate. If it doesn't exist, show 'TBD' instead
	const parseItemsWithDetails = (data, isEstimate) =>
		data.map((item, index) => {
			let { Hours } = item;
			if (item.TimeCard && !isEstimate) {
				const {
					TimeCard: { ClockInTime, ClockOutTime },
				} = item;
				const clockIn = new Date(`${ClockInTime}Z`).getTime();
				const clockOut = new Date(`${ClockOutTime}Z`).getTime();
				if (!Number.isNaN(clockIn) && !Number.isNaN(clockOut)) {
					Hours = ((clockOut - clockIn) / 3600000).toFixed(2);
				} else {
					Hours = 0;
				}
			}
			return {
				...item,
				Hours,
				Fees: item.Fees || [],
				JobAssignmentId: item.JobAssignmentId || `${item.JobEventId}_${index}`,
				OfficerName: item.OfficerName || "TBD",
			};
		});

	/**
	 * Creates a new list of job line items associated with the invoice
	 * @param {Array} data The list of job line items
	 */
	const setLineItemsData = data => {
		const { isEstimate } = invoiceState;
		const items = parseItemsWithDetails(data, isEstimate);

		setMissingTimecardModal(undefined);
		dispatchInvoice({ type: NONRKPAYINVOICE_ACTIONS.ADD_LINE_ITEMS, payload: items });
		setForceFetchInvoiceDraftTotals(true);
		setForceCheckExcludeOfficerRate(true);
	};

	/**
	 * Creates a new list of job line items associated with the invoice
	 * @param {Array} data The list of job line items
	 */
	const overrideLineItemsWithData = data => {
		const { isEstimate } = invoiceState;
		const items = parseItemsWithDetails(data, isEstimate);

		setMissingTimecardModal(undefined);
		dispatchInvoice({ type: NONRKPAYINVOICE_ACTIONS.OVERRIDE_LINE_ITEMS, payload: items });
		setForceFetchInvoiceDraftTotals(true);
		setForceCheckExcludeOfficerRate(true);
	};

	const filterFeeTypesToUser = fees => {
		let filteredFees = [...fees];

		if (!user.isInvoicingV3()) {
			filteredFees = filteredFees.filter(
				ft => ft.Id !== NON_RK_PAY_FEE_TYPES.COORDINATION_FEE,
			);
		}

		if (user.isCoordinator()) {
			filteredFees = filteredFees.filter(
				ft => ft.Id === NON_RK_PAY_FEE_TYPES.COORDINATION_FEE,
			);
		}

		if (query.estimate === "true") {
			filteredFees = filteredFees.filter(
				ft => ft.Id !== NON_RK_PAY_FEE_TYPES.MISC_PERSONNEL_FEE,
			);
		}

		return filteredFees;
	};

	const returnToList = () => {
		const { isEstimate } = invoiceState;
		router.push(
			`/payments/manual${query.estimate === "true" || isEstimate ? "?estimate=true" : ""}`,
		);
	};

	/** Event listener that checks for clicks on the 'actions-menu' button dropdown
	 * @param {Event} event The HTML event that informs us what was clicked on
	 */
	const clickEventListener = ({ target }) => {
		const dropdown = document.getElementById("actions-menu");
		if (dropdown?.classList.contains("open") && !target.closest("#actions-menu")) {
			dropdown.classList.remove("open");
		}
	};

	// invoiceChangeDiff has to use useCallback since it is used in the useEffect
	// if we don't use useCallback adding all the dependencies, all the state variables
	// are not going to be updated with the last value
	// *Important: If a new value from the state is added into invoiceChangeDiff, it has
	// to be added into the dependencies array of the function.
	const invoiceChangeDiff = useCallback(
		({ pathname }) => {
			const { archived, finalized, voided } = invoiceState;
			// If the user has confirmed their intent to leave the page, allow transition no matter what
			if (confirmedExit) return true;

			const currentInvoice = buildInvoiceObject(true);

			if (
				currentInvoice.Id &&
				!isEqual(originalInvoice, currentInvoice) &&
				!finalized &&
				!voided &&
				!archived
			) {
				confirmationModal.current.openModal({
					title: lang.t("Save Changes"),
					message: `${lang.t("You have unsaved changes_")} ${lang.t("Would you like to save before leaving this invoice_")}`,
					confirmButton: lang.t("Save Changes"),
					cancelButton: lang.t("Discard Changes"),
					onHide: () => {},
					onCancel: () => {
						setConfirmedExit(true);
						setPathnameToGo(pathname);
					},
					onConfirm: () => {
						handleSubmit(false, true, () => {
							setConfirmedExit(true);
							router.push(pathname);
						});
					},
				});
				return false;
			}
			return true;
		},
		[
			invoiceState,
			originalInvoice,
			confirmedExit,
			buildInvoiceObject,
			selectedClient,
			invoiceState.totals,
			invoiceState.lineItems,
			router,
		],
	);

	/**
	 * A handler function is required since invoice data can be returned via GET, POST, and PUT methods
	 * @param {Object}
	 */
	const handleInvoiceData = (data, initial = false) =>
		new Promise(resolve => {
			const {
				Organization: { OrganizationLogo },
			} = user;

			checkExcludeOfficerRateLineItems();

			const { ClientLocationAddress, NotesToClient } = data;

			dispatchInvoice({
				type: NONRKPAYINVOICE_ACTIONS.HANDLE_INVOICE_DATA,
				payload: { data, organizationLogo: OrganizationLogo },
			});

			setOriginalInvoice({
				...data,
				// Rewritten replacing null with '' in order to avoid incorrect comparison results
				// null cannot be used since these are values provided to inputs on the page
				NotesToClient: NotesToClient ?? "",
				ClientLocationAddress: {
					...(ClientLocationAddress || {}),
					StreetAddress: ClientLocationAddress?.StreetAddress || "",
					City: ClientLocationAddress?.City || "",
					StateId: ClientLocationAddress?.StateId || "",
					StateName: ClientLocationAddress?.StateName || "",
					StateAbbreviation: ClientLocationAddress?.StateAbbreviation || "",
					Zip: ClientLocationAddress?.Zip || "",
				},
				Fees: data.Fees.sort((a, b) => a.Id - b.Id),
				Items: data.Items.map(item => ({
					...item,
					Fees: item.Fees.sort((a, b) => a.Id - b.Id),
				})).sort((a, b) => utils.compareLineItemsByDateAndOfficerName(a, b)),
			});

			setSelectedClient({
				value: data.ClientId,
				label: data.ClientName,
			});

			setIsInvoicingV3(Features.some(f => f.toLowerCase() === "invoicingv3"));
			setAttachments(data.Attachments || 0);
			setNotes(data.TimecardNotesCount || 0);

			setForceCheckExcludeOfficerRate(true);

			// The invoiceState.lineItems state is updated asynchronously by multiple API calls (getInvoiceDetails and getNonRKPayLineItems).
			// Originally, setLineItems was called in both functions, causing a race condition where the second API call
			// could overwrite the invoiceState.lineItems state before the first one had finished updating it. As a result, some data
			// from the first API call (getInvoiceDetails) was being lost.
			//
			// To resolve this, we introduced (newLineItemsToAdd and initialInvoiceLoadFinished) to temporarily store the result from the second
			// API call (getNonRKPayLineItems). We then used a useEffect to listen for changes to newLineItemsToAdd and initialInvoiceLoadFinished
			// state, and once both API calls have completed, we update the final invoiceState.lineItems state with the
			// combined data. This ensures that the state is updated only after both API calls have finished and avoids overwriting any data.
			if (initial) setInitialInvoiceLoadFinished(true);
			resolve(data);
		});

	const confirmLineItemsRefresh = async () => {
		const { isEstimate, lineItems } = invoiceState;

		if (!isRegenerateEstimateItemsEnabled) {
			const jobIds = lineItems.map(({ JobEventId }) => JobEventId);
			const { data } = await InvoiceService.getNonRKPayLineItems(!isEstimate, jobIds);

			setLineItemUpdates(data);
			setShowUpdateLineItemsModal(true);
			return;
		}

		if (isEstimate) {
			const currentInvoice = buildInvoiceObject(true);

			if (!isEqual(originalInvoice, currentInvoice)) {
				confirmationModal.current.openModal({
					title: lang.t("Save Changes"),
					message: lang.t(
						"There are unsaved changes on this estimate. Would you like to save these before applying job updates?"
					),
					confirmButton: lang.t("Save and apply updates"),
					onConfirm: () => handleSubmit(false, true, () => refreshEstimateItems()),
				});
				return;
			}

			refreshEstimateItems();
			return;
		}

		refreshInvoiceItems();
	};

	const refreshInvoiceItems = async () => {
		const { lineItems } = invoiceState;
		const jobIds = lineItems.map(({ JobEventId }) => JobEventId);

		const data = await reGenerateInvoiceItems(jobIds);

		if (!data) return;

		setLineItemUpdates(data);
		setShowUpdateLineItemsModal(true);
	}

	const refreshEstimateItems = async () => {
		const { invoiceId } = invoiceState;

		const data = await reGenerateEstimateItems(invoiceId);

		if (!data) return;

		setLineItemUpdates(data);
		setShowUpdateLineItemsModal(true);
	}

	const updateLineItems = () => {
		const { isEstimate } = invoiceState;
		const [...items] = lineItemUpdates;
		if (!isEstimate && items.some(({ TimeCard }) => TimeCard === null)) {
			setMissingTimecardModal({ show: true, items, updatingLineItems: true });
		} else {
			overrideLineItemsWithData(items);
		}
		setLineItemUpdates([]);
	};

	const onConfirmMissingTimecardModal = () => {
		const { isEstimate } = invoiceState;

		if (missingTimecardModal.creatingInvoiceFromEstimate && isEstimate) {
			setMissingTimecardModal(undefined);
			setShowGenerateEstimateInvoiceModal(true);
			return;
		}

		if (missingTimecardModal.updatingLineItems) {
			overrideLineItemsWithData(missingTimecardModal.items);
		} else {
			setLineItemsData(missingTimecardModal.items);
			if (missingTimecardModal.addingLineItemsFromUri) setAddingLineItemsFromUri(true);
		}

		if (isEstimate) setForceShowConvertEstimateModal(true);
	};

	const setAppliedPayments = async ({ id }) => {
		const paymentsData = await fetchPayments(id);
		if (paymentsData) setPaymentData(paymentsData);

		const invoiceData = await getInvoiceDetails(id);
		if (invoiceData) handleInvoiceData(invoiceData);

		if (nonrkpayDetailPrepayEnhancementsEnabled && invoiceData && invoiceData.IsEstimate) {
			const availableFundsData = await fetchAvailableFunds(query.id);
			if (availableFundsData) setAvailableFunds(availableFundsData);
		}
	};

	const handleInvoiceChange = property => event => {
		const {
			target: { value },
		} = event;
		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_INVOICE_PROPERTY_DATA,
			payload: { property, value },
		});
	};

	const handleFromChange = property => event => {
		const {
			target: { value },
		} = event;
		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_FROM_PROPERTY_DATA,
			payload: { property, value },
		});
	};

	const handleBillToChange = property => event => {
		let {
			target: { value },
		} = event;
		if (property === "zip") value = value.replace(/\D/gi, "");
		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_BILL_TO_PROPERTY_DATA,
			payload: { property, value },
		});
	};

	const handleBillToStateChange = (stateId, stateName, stateAbbreviation) => {
		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_BILL_TO_STATE_DATA,
			payload: {
				stateId,
				stateName,
				stateAbbreviation,
			},
		});
	};

	/**
	 * Retrieves the client invoice disclaimer
	 * @param {Number} clientId The uniqe id of the client
	 */
	const getClientInvoiceDisclaimer = async clientId => {
		try {
			const { data } = await ClientService.getById(clientId);
			const { ClientInvoiceDisclaimer } = data;
			return ClientInvoiceDisclaimer;
		} catch (e) {
			utils.notify({
				type: "error",
				message: lang.t("Error retrieving client details"),
				timeOut: 2000,
			});
			return null;
		}
	};

	/**
	 * Handles any changes made to the client
	 * If a new client is selected, all invoice data will be cleared and the user will be prompted to confitm this action
	 * @param {Event} event The HTML event handled by this method
	 */
	const handleClientChange = event => {
		const { invoiceId, isEstimate, prePay } = invoiceState;
		// Set new client if selected and reset billing information, line items, and totals
		const changeClient = async () => {
			setSelectedClient(event || { value: "", label: "" });
			dispatchInvoice({ type: NONRKPAYINVOICE_ACTIONS.HANDLE_CLIENT_CHANGE });
			setCustomFee({
				Name: "",
				Total: "",
				nameError: false,
				totalError: false,
			});

			if (event?.BillingContactId) {
				const billingContactData = await getBillingContact(event.BillingContactId);
				if (billingContactData)
					dispatchInvoice({
						type: NONRKPAYINVOICE_ACTIONS.SET_BILLING_CONTACT,
						payload: billingContactData,
					});
			}
			determineInvoiceDisclaimer(true, event);

			if (isInvoicingV3 && isEstimate && (!invoiceId || invoiceId === "")) {
				const enforcesV2 = event?.EnforceV2NonRKPayInvoicing;
				const desiredPrepayValue = !enforcesV2;

				if (prePay !== desiredPrepayValue) {
					dispatchInvoice({
						type: NONRKPAYINVOICE_ACTIONS.SET_INVOICE_PROPERTY_DATA,
						payload: { property: "prePay", value: desiredPrepayValue },
					});
				}
			}
		};

		if (event?.value === selectedClient.value) return;
		if (invoiceId !== "" && event?.value !== selectedClient.value) {
			confirmationModal.current.openModal({
				title: lang.t("Changing Client"),
				message: `${lang.t("Any previously associated job items will be lost_")}
							  ${lang.t("Are you sure you want to change the business being invoiced_")}`,
				confirmButton: lang.t("Yes"),
				onCancel: () => setSelectedClient(prevState => prevState),
				onConfirm: changeClient,
			});
		} else changeClient();
	};

	/** Displays a modal which allows the user to add more jobs items to the invoice */
	const handleClickAddJobs = () => {
		const { isEstimate } = invoiceState;
		addJobsModal.current.openModal({
			client: {
				isEstimate,
				id: selectedClient.value,
				name: selectedClient.label,
			},
			onSave: jobIds => addJobsLineItems(jobIds, isEstimate),
		});
	};

	const addJobsLineItems = async (jobIds, isEstimate) => {
		const lineItemsData = await fetchNonRKPayLineItemsForJobs(!isEstimate, jobIds);
		if (!lineItemsData) return;

		if (!isEstimate && lineItemsData.some(({ TimeCard }) => TimeCard === null)) {
			setMissingTimecardModal({ show: true, items: lineItemsData });
		} else {
			setLineItemsData(lineItemsData);
			setForceCheckExcludeOfficerRate(true);
		}
	};

	const handleRemoveLineItem = jobEventId => {
		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.REMOVE_LINE_ITEM,
			payload: { jobEventId },
		});
		setDeletingOfficerViewJob(undefined);
		setForceFetchInvoiceDraftTotals(true);
	};

	const handlePositionChange = (jobAssignmentId, property) => event => {
		const {
			target: { value },
		} = event;

		if (parseFloat(value) < 0) return;

		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_LINE_ITEM_POSITION,
			payload: { jobAssignmentId, property, value },
		});
	};

	const toggleLineFees = jobAssignmentId => {
		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.TOGGLE_LINE_FEES,
			payload: { jobAssignmentId },
		});
	};

	/**
	 * Displays the UI that allows users to add a new fee to a specific line item
	 * @param {Number} jobAssignmentId The `JobAssignmentId` for a line item
	 */
	const toggleNewLineFee = jobAssignmentId => {
		const { newLineFeeToggler } = invoiceState;
		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_NEW_LINE_FEE_TOGGLER,
			payload: { jobAssignmentId },
		});
		if (newLineFeeToggler[jobAssignmentId]) {
			dispatchInvoice({
				type: NONRKPAYINVOICE_ACTIONS.SET_NEW_LINE_FEE_TOGGLER,
				payload: { jobAssignmentId, newFee: undefined },
			});
		} else {
			dispatchInvoice({
				type: NONRKPAYINVOICE_ACTIONS.SET_NEW_LINE_FEE_TOGGLER,
				payload: {
					jobAssignmentId,
					newFee: {
						feeType: "",
						agencyFeeOptions: [],
						selectedFeeId: "",
						feeName: "",
						feeRate: "",
						calcType: "1",
					},
				},
			});
		}
	};

	const handleAddFeeClick = jobAssignmentId => {
		const { newLineFeeToggler } = invoiceState;

		toggleLineFees(jobAssignmentId);
		if (!newLineFeeToggler[jobAssignmentId]) {
			toggleNewLineFee(jobAssignmentId);
		}
	};

	/**
	 * Handles changes to the new line item fee fields
	 * @param {Number} jobAssignmentId The `JobAssignmentId` for a line item
	 * @param {Event} e The HTML event handled by this method
	 */
	const handleNewFeeChange = (jobAssignmentId, e) => {
		e.persist();
		const { newLineFeeToggler, lineItems } = invoiceState;
		const { JurisdictionFees, JurisdictionAssets, JurisdictionVehicleFees } = agencyFeePresets;
		const { [jobAssignmentId]: newFee } = newLineFeeToggler;
		const {
			target: { name, value },
		} = e;
		const property = name.split("-").at(-1);

		if ((property === "feeRate" && value.match(/^\d*\.?\d{0,2}$/g)) || property !== "feeRate") {
			newFee[property] = value;
		}
		if (property === "feeType") {
			switch (value) {
				case "2":
					newFee.agencyFeeOptions = JurisdictionFees;
					break;
				case "3":
					newFee.agencyFeeOptions = JurisdictionAssets;
					break;
				case "4":
					newFee.agencyFeeOptions = vehicleTypes;
					break;
				default:
					newFee.agencyFeeOptions = [];
					break;
			}

			if (value === "1") {
				const lineItemInfo = lineItems.find(
					item => item.JobAssignmentId === jobAssignmentId,
				);
				newFee.feeName = "Coordination Fee";
				newFee.feeRate = lineItemInfo.ClientCoordinationFee || "";
				newFee.calcType = "2";
				newFee.selectedFeeId = "";
			} else if (value === "4") {
				const [firstVehicle] = vehicleTypes;
				const vehicleFeeInfo =
					JurisdictionVehicleFees.find(f => f.VehicleTypeId === firstVehicle?.Id) || {};
				newFee.selectedFeeId = vehicleFeeInfo.Id || "";
				newFee.feeName = firstVehicle.Name || "";
				newFee.feeRate = vehicleFeeInfo.Rate || "";
				newFee.calcType = vehicleFeeInfo.CalculationType || "1";
			} else {
				newFee.selectedFeeId = newFee.agencyFeeOptions.length
					? newFee.agencyFeeOptions[0].Id
					: "";
				newFee.feeName = newFee.agencyFeeOptions.length
					? newFee.agencyFeeOptions[0].Description
					: "";
				newFee.feeRate = newFee.agencyFeeOptions.length
					? newFee.agencyFeeOptions[0].Rate
					: "";
				newFee.calcType = newFee.agencyFeeOptions.length
					? newFee.agencyFeeOptions[0].CalculationType
					: "1";
			}
		} else if (property === "selectedFeeId" && newFee.feeType === "4" && value !== "") {
			// Changing selected vehicle
			const selectedVehicle = vehicleTypes.find(v => v.Id.toString() === value) || {};
			const vehicleFeeInfo =
				JurisdictionVehicleFees.find(f => f.VehicleTypeId.toString() === value) || {};
			newFee.feeName = selectedVehicle.Name || "";
			newFee.feeRate = vehicleFeeInfo.Rate || "";
			newFee.calcType = vehicleFeeInfo.CalculationType || "1";
		} else if (property === "selectedFeeId" && value !== "") {
			const selectedFee = newFee.agencyFeeOptions.find(f => f.Id.toString() === value);
			newFee.feeName = selectedFee.Description;
			newFee.feeRate = selectedFee.Rate;
			newFee.calcType = selectedFee.CalculationType;
		} else if (property === "selectedFeeId") {
			newFee.feeName = "";
			newFee.feeRate = "";
			newFee.calcType = "1";
		}

		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_NEW_LINE_FEE_TOGGLER,
			payload: { jobAssignmentId, newFee },
		});
	};

	/**
	 * Hides the custom fee name field and shows the list of predefined fees for the selected fee type
	 * @param {Number} jobAssignmentId The `JobAssignmentId` for a line item
	 */
	const clearNewLineFeeName = jobAssignmentId => {
		const { newLineFeeToggler } = invoiceState;
		const { JurisdictionVehicleFees } = agencyFeePresets;
		const { [jobAssignmentId]: newFee } = newLineFeeToggler;

		if (newFee.feeType === "4") {
			const [firstVehicle] = vehicleTypes;
			const vehicleFeeInfo =
				JurisdictionVehicleFees.find(f => f.VehicleTypeId === firstVehicle?.Id) || {};
			newFee.selectedFeeId = vehicleFeeInfo.Id || "";
			newFee.feeName = firstVehicle.Name || "";
			newFee.feeRate = vehicleFeeInfo.Rate || "";
			newFee.calcType = vehicleFeeInfo.CalculationType || "1";
		} else {
			newFee.selectedFeeId = newFee.agencyFeeOptions[0].Id;
			newFee.feeName = newFee.agencyFeeOptions[0].Description;
			newFee.feeRate = newFee.agencyFeeOptions[0].Rate;
			newFee.calcType = newFee.agencyFeeOptions[0].CalculationType;
		}

		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_NEW_LINE_FEE_TOGGLER,
			payload: { jobAssignmentId, newFee },
		});
	};

	const alreadyHasCoordinationFee = fees => fees.some(fee => fee.NonRKPayInvoiceFeeTypeId === 1);

	const mapLineItemsFeesToDraftItemFees = fees =>
		fees.map((fee, index) => ({
			Index: index,
			Name: fee.Name,
			NonRKPayInvoiceFeeTypeId: fee.NonRKPayInvoiceFeeTypeId,
			CalculationType: fee.CalculationType,
			Rate: fee.Rate,
		}));

	const mapLineItemsToDraftItems = lineItemsInput =>
		lineItemsInput.map((item, index) => ({
			Hours: item.Hours,
			Rate: item.Rate,
			Fees: mapLineItemsFeesToDraftItemFees(item.Fees),
			ExcludeOfficerRate: item.ExcludeOfficerRate,
			Index: index,
		}));

	const handleInvoiceDraftTotals = data => {
		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.HANDLE_INOVICE_DRAFT_TOTALS,
			payload: data,
		});

		// Reset all _changed and _totalModified flags after totals are up-to-date
		setTimeout(() => {
			dispatchInvoice({ type: NONRKPAYINVOICE_ACTIONS.RESET_LINE_ITEMS_CHANGED_STATE });
			clearTimeout();
		}, 750);
	};

	const handlePositionChangedOnBlur = async jobAssignmentId => {
		const { lineItems } = invoiceState;
		const lineItem = lineItems.find(item => item.JobAssignmentId === jobAssignmentId);
		if (!lineItem) return;
		if (lineItem.Rate < 0 || lineItem.Hours < 0) {
			utils.notify({
				type: "error",
				message: lang.t("Rate and Hours value cannot be negative"),
				timeOut: 2000,
			});
			return;
		}
		if (lineItem._changed) {
			const draftTotals = await getNonRKPayInvoiceDraftTotals();
			if (draftTotals) handleInvoiceDraftTotals(draftTotals);
		}
	};

	const handlePositionFeeChangedOnBlur = async (jobAssignmentId, id, isFeeId = false) => {
		const { lineItems } = invoiceState;
		const lineItem = lineItems.find(item => item.JobAssignmentId === jobAssignmentId);
		if (!lineItem) return;
		const lineItemFee = lineItem.Fees.find(
			(fee, index) => (isFeeId && fee.Id === id) || (!isFeeId && index === id),
		);
		if (!lineItemFee) return;
		if (lineItemFee._changed) {
			const draftTotals = await getNonRKPayInvoiceDraftTotals();
			if (draftTotals) handleInvoiceDraftTotals(draftTotals);
		}
	};

	/**
	 * Adds a new fee to the selected line item based on the information in the new line item fee fields
	 * @param {Number} jobAssignmentId The `JobAssignmentId` for a line item
	 */
	const addNewLineFee = jobAssignmentId => {
		const { newLineFeeToggler, lineItems } = invoiceState;
		const { [jobAssignmentId]: newFee } = newLineFeeToggler;
		const newLineItems = lineItems.map(item => {
			if (item.JobAssignmentId === jobAssignmentId) {
				if (parseFloat(newFee.feeRate) <= 0) {
					utils.notify({
						type: "error",
						message: lang.t("Rate value has to be positive"),
						timeOut: 2000,
					});
					return item;
				}

				if (Number(newFee.feeType) === 1 && alreadyHasCoordinationFee(item.Fees)) {
					utils.notify({
						type: "error",
						message: lang.t("There is already a coordination fee for the current job"),
						timeOut: 2000,
					});
					return item;
				}

				const feeTypeName = feeTypes.find(ft => ft.Id.toString() === newFee.feeType).Name;
				const fee = {
					CalculationType: Number(newFee.calcType),
					Name: newFee.feeName,
					NonRKPayInvoiceFeeTypeId: Number(newFee.feeType),
					NonRKPayInvoiceFeeTypeName: feeTypeName,
					NonRKPayInvoiceItemId: item.Id || 0,
					Rate: Number(newFee.feeRate) / (newFee.calcType.toString() === "3" ? 100 : 1),
				};

				item.Fees.push(fee);
			}
			return item;
		});

		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.ADD_NEW_LINE_ITEM_FEE,
			payload: { lineItems: newLineItems, jobAssignmentId },
		});
		setForceFetchInvoiceDraftTotals(true);
	};

	const togglePaymentHistory = () => setShowPaymentHistory(!showPaymentHistory);

	const togglePrePay = () => {
		const { prePay } = invoiceState;
		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_INVOICE_PROPERTY_DATA,
			payload: { property: "prePay", value: !prePay },
		});
	};

	const toggleAttachmentsModal = (newSelectedAttachment = {}) => {
		setShowAttachmentsModal(!showAttachmentsModal);
		setSelectedAttachment(newSelectedAttachment);
	};

	const toggleTimeCardNotesModal = (newSelectedNote = {}) => {
		setShowTimeCardNotesModal(!showTimeCardNotesModal);
		setSelectedNote(newSelectedNote);
	};

	const toggleConnectedInvoicesModal = () => {
		setShowConnectedInvoicesModal(!showConnectedInvoicesModal);
	};

	const toggleInternalNotesModal = () => setShowInternalNotesModal(!showInternalNotesModal);

	/**
	 * Handles updates made to the a jobs items fees
	 * @param {Number} jobAssignmentId The unique id of the job
	 * @param {Number} id the uniqe id of the fee related to the job
	 * @param {Boolean} isFeeId Validates the existence fee id
	 * @returns {Array} The up to date job line items
	 */
	const handlePositionFeeChange =
		(jobAssignmentId, id, isFeeId = false) =>
		event => {
			const {
				target: { value },
			} = event;
			const { lineItems } = invoiceState;
			if (parseFloat(value) < 0) return;

			const newLineItems = lineItems.map(item => {
				// Find the matching line item using jobAssignmentId
				if (item.JobAssignmentId === jobAssignmentId) {
					return {
						...item,
						Fees: item.Fees.map((fee, index) => {
							// Update the fee total using either Id or index
							if ((isFeeId && fee.Id === id) || (!isFeeId && index === id)) {
								return {
									...fee,
									CalculationType: 1,
									Total: value,
									Rate: value,
									totalError: false,
									_changed: true,
								};
							}
							return fee;
						}),
					};
				}
				return item;
			});

			dispatchInvoice({
				type: NONRKPAYINVOICE_ACTIONS.SET_LINE_ITEMS,
				payload: newLineItems,
			});
		};

	/**
	 * Deletes the selected fee from a job item and updates the invoice total after removal
	 * @param {Number} jobAssignmentId The unique id of the job
	 * @param {Number} id the uniqe id of the fee related to the job
	 * @param {Boolean} isFeeId Validates the existence fee id
	 */
	const deletePositionFee = (jobAssignmentId, id, isFeeId = false) => {
		const { lineItems } = invoiceState;
		const newLineItems = lineItems.map(item => {
			// Find the matching line item using jobAssignmentId
			if (item.JobAssignmentId === jobAssignmentId) {
				return {
					...item,
					Fees: item.Fees.filter(
						(fee, index) => (isFeeId && fee.Id !== id) || (!isFeeId && index !== id),
					),
				};
			}
			return item;
		});
		dispatchInvoice({ type: NONRKPAYINVOICE_ACTIONS.SET_LINE_ITEMS, payload: newLineItems });
		setForceFetchInvoiceDraftTotals(true);
	};

	const handleCustomFeeChange = property => event => {
		const {
			target: { value },
		} = event;
		setCustomFee(prevState => ({
			...prevState,
			[property]: value,
		}));
	};

	/** Adds on custom fees to an already established invoice and updates the invoices total payable amount */
	const createCustomFee = () => {
		const {
			totals: { additionalFees },
		} = invoiceState;
		const { ...newCustomFee } = customFee;
		newCustomFee.nameError = newCustomFee.Name.trim() === "";
		newCustomFee.totalError =
			newCustomFee.Total.trim() === "" ||
			Number.isNaN(parseInt(newCustomFee.Total, 10)) ||
			parseFloat(newCustomFee.Total) <= 0;

		if (newCustomFee.nameError || newCustomFee.totalError) {
			setCustomFee(newCustomFee);
			return;
		}
		const { Name, Total } = newCustomFee;
		setCustomFee({
			Name: "",
			Total: "",
			nameError: false,
			totalError: false,
		});

		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_ADDITIONAL_FEES_TOTALS,
			payload: [...additionalFees, { Name, Total }],
		});
		setForceFetchInvoiceDraftTotals(true);
	};

	/**
	 * Deletes and removes the selected custom fee and updates the invoice total after removal
	 * @param {Number} index The index of the fee being deleted
	 */
	const deleteCustomFee = index => {
		const {
			totals: { additionalFees },
		} = invoiceState;
		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_ADDITIONAL_FEES_TOTALS,
			payload: [...additionalFees.filter((fee, idx) => idx !== index)],
		});
		setForceFetchInvoiceDraftTotals(true);
	};

	const toggleActionsDropdown = () => {
		const dropdown = document.getElementById("actions-menu");
		if (dropdown.classList.contains("open")) {
			dropdown.classList.remove("open");
			updateActionsChevron(true);
		} else {
			dropdown.classList.add("open");
			updateActionsChevron(false);
		}
	};

	const updateActionsChevron = down => {
		const actionsCheveron = document.getElementById("nonrkpay-invoice-actions-chevron");

		if (!actionsCheveron) return;

		if (down) {
			actionsCheveron.classList.remove("rkf-chevron-up");
			actionsCheveron.classList.add("rkf-chevron-down");
		} else {
			actionsCheveron.classList.remove("rkf-chevron-down");
			actionsCheveron.classList.add("rkf-chevron-up");
		}
	};

	const validateInvoice = () => {
		const { isEstimate, billTo, lineItems } = invoiceState;
		// Destructuring these separately so that they can be modified as needed if the user is on Safari or IE
		let { issueDate, dueDate } = invoiceState;

		// Clean up the issue date and due date strings to prevent any unseen characters being inserted on IE11;
		issueDate = utils.fixIELocaleString(issueDate);
		dueDate = utils.fixIELocaleString(dueDate);

		/* Invoice date validation */
		if (!isEstimate && (issueDate === "" || dueDate === "")) {
			utils.notify({
				type: "error",
				message: lang.t("Issue Date and Due Date are required to save an invoice"),
				timeOut: 2000,
			});
			return false;
		}
		if (!isEstimate && new Date(issueDate).getTime() > new Date(dueDate).getTime()) {
			utils.notify({
				type: "error",
				message: lang.t("Invoice due date must be on or after the issue date"),
				timeOut: 2000,
			});
			return false;
		}
		if (isEstimate && issueDate === "") {
			utils.notify({
				type: "error",
				message: lang.t("Issue date required to create an estimate"),
				timeOut: 2000,
			});
			return false;
		}

		if (!billTo.contact || billTo.contact === "") {
			utils.notify({
				type: "error",
				message: lang.t("Billing contact is required"),
				timeOut: 2000,
			});
			return false;
		}

		if (!billTo.email || billTo.email === "") {
			utils.notify({
				type: "error",
				message: lang.t("Billing contact email is required"),
				timeOut: 2000,
			});
			return false;
		}

		if (useStrictValidationForInvoiceClientEmailEnabled && !utils.isValidEmailStrict(billTo.email)) {
			utils.notify({
				type: "error",
				message: lang.t("Billing contact email format is invalid"),
				timeOut: 2000,
			});
			return false;
		}

		let {
			billTo: { phone: BillPhone },
		} = invoiceState;
		let {
			from: { phone: FromPhone },
		} = invoiceState;

		FromPhone = utils.revertPhoneMask(FromPhone);
		BillPhone = utils.revertPhoneMask(BillPhone);

		if (FromPhone.length < 10 || BillPhone.length < 10) {
			utils.notify({
				type: "error",
				message: lang.t("The phone number must be 10 digits long_"),
				timeOut: 2000,
			});
			return false;
		}

		/* Estimate address validation */
		if (
			isInvoicingV3 &&
			(!billTo.streetAddress || !billTo.city || !billTo.stateId || !billTo.zip)
		) {
			utils.notify({
				type: "error",
				message: lang.t("Billing address is required"),
				timeOut: 2000,
			});
			return false;
		}

		const newLineItems = lineItems.map(item => ({
			...item,
			Fees: item.Fees.map(fee => {
				if (Number.isNaN(fee.Total) || Number(fee.Total) < 0) {
					utils.notify({
						type: "error",
						message: lang.t("Fee value cannot be negative"),
						timeOut: 2000,
					});
					return { ...fee, totalError: true };
				}
				return fee;
			}),
		}));

		dispatchInvoice({ type: NONRKPAYINVOICE_ACTIONS.SET_LINE_ITEMS, payload: newLineItems });

		const validFees = !newLineItems.some(item =>
			item.Fees.some(fee => fee.totalError === true),
		);

		if (!validFees) return false;

		return true;
	};

	/**
	 * Gathers all required information neccessary for submiting changes made to an invoice or estimate
	 * @param {Boolean} convertingEstimate Determines if the estimate needs to be converted to an invoice
	 * @param {Boolean} showSpinner Determines when to display a page loader after submitting invoice/estimate changes
	 * @param {Funciton} callback A callback method which handles subsequent actoins such as sending an invoice to the clients email
	 */
	// eslint-disable-next-line default-param-last
	const handleSubmit = async (convertingEstimate = false, showSpinner = true, callback) => {
		const { isEstimate } = invoiceState;

		if (!validateInvoice()) return;

		if (showSpinner) setSavingInvoice(true);
		const invoiceObject = buildInvoiceObject();

		if (invoiceObject.Id && invoiceObject.Id !== "") {
			try {
				const { data } = await InvoiceService.updateNonRKPayInvoice(invoiceObject);
				const { push } = router;
				if (showSpinner) {
					utils.notify({
						type: "success",
						message: lang.t(
							convertingEstimate
								? "Estimate converted successfully"
								: "Updated successfully",
						),
						timeOut: 2000,
					});
				}
				if (convertingEstimate) {
					// Remove `estimate=true` from query params to clear any potential user confusion
					push(`/payments/manualinvoice?id=${invoiceObject.Id}`);
				}
				if (addingLineItemsFromUri && query.clientId && query.jobs) {
					// Remove the clientId and the jobs from the query params if we are updating an invoice with new lineItems
					push(
						`/payments/manualinvoice?id=${data.Id}${isEstimate ? "&estimate=true" : ""}`,
					);
					setAddingLineItemsFromUri(false);
				}
				// Set totals in memory based on data received from the update
				await handleInvoiceData(data);
				if (callback) callback();

				if (!data.IsEstimate && data.EstimateId !== null) {
					const paymentsData = await fetchPayments(data.Id);
					if (paymentsData) setPaymentData(paymentsData);
				}
			} catch (e) {
				utils.notify({
					type: "error",
					message: lang.t(
						convertingEstimate ? "Error converting estimate" : "Error saving invoice",
					),
				});

				const invoiceData = await getInvoiceDetails(invoiceObject.Id);
				if (invoiceData) await handleInvoiceData(invoiceData);
			} finally {
				setSavingInvoice(false);
			}
		} else {
			try {
				const { data } = await InvoiceService.createNonRKPayInvoice(invoiceObject);
				const { push } = router;
				await handleInvoiceData(data);
				if (showSpinner) {
					utils.notify({
						type: "success",
						message: lang.t(
							isEstimate
								? "Estimate created successfully"
								: "Invoice created successfully",
						),
						timeOut: 2000,
					});
				}
				push(`/payments/manualinvoice?id=${data.Id}${isEstimate ? "&estimate=true" : ""}`);
				if (callback) callback();
			} catch (e) {
				utils.notify({
					type: "error",
					message: lang.t(isEstimate ? "Error saving estimate" : "Error saving invoice"),
					timeOut: 2000,
				});
			} finally {
				setSavingInvoice(false);
			}
		}
	};

	const refundBalance = async () => {
		const { invoiceId, isEstimate, invoiceVersion } = invoiceState;

		if (isEstimate && invoiceVersion === 2) {
			await handleRefundEstimate(invoiceId);
			return;
		}

		const refundData = await refundInvoice(invoiceId);
		if (!refundData) return;

		const invoiceData = await getInvoiceDetails(invoiceId);
		if (invoiceData) await handleInvoiceData(invoiceData);

		const paymentsData = await fetchPayments(invoiceId);
		if (paymentsData) setPaymentData(paymentsData);

		const refundInTransitData = await fetchRefundsInTransit(invoiceId);
		if (refundInTransitData) setRefundsInTransit(refundInTransitData);
	};

	const toggleRefundModal = balance => {
		confirmationModal.current.openModal({
			title: lang.t("Refund Balance"),
			message:
				lang.t(`Are you sure you would like to refund the amount of ${utils.currencyFormatter(Math.abs(balance))}?
									  The refund within the platform will be shown as pending and in transit until the refund is successful in Stripe.`),
			confirmButton: lang.t("Refund"),
			onCancel: () => setRefundingInvoice(false),
			onConfirm: () => refundBalance(),
		});
	};

	const voidAndRefundEstimate = () => {
		const {
			invoiceId,
			invoiceNumber,
			totals: { appliedPayments },
		} = invoiceState;

		const onConfirmVoidAndRefund = async () => {
			const voided = await voidInvoice(invoiceId, true);

			if (!voided) return;

			dispatchInvoice({
				type: NONRKPAYINVOICE_ACTIONS.SET_INVOICE_PROPERTY_DATA,
				payload: { property: "voided", value: true },
			});

			await handleRefundEstimate(invoiceId);
		};

		confirmationModal.current.openModal({
			title: `${lang.t("Void & Refund Estimate")}`,
			message: (
				<span>
					{lang.t("Are you sure you want to void")}&nbsp;
					{lang.t("Estimate").toLowerCase()} <strong>{invoiceNumber}</strong>?
					<br />
					<br />
					{lang.t(
						"Voiding this estimate will also trigger a refund for the amount below",
					)}
					:
					<br />
					<br />
					<strong>
						{lang.t("dynamic.Void & Refund Estimate refund amount", {
							appliedPayments,
						})}
					</strong>
					<br />
					<br />
					{lang.t("This action cannot be undone_")}
					<br />
				</span>
			),
			cancelButton: lang.t("Cancel"),
			confirmButton: `${lang.t("Confirm Void & Refund")}`,
			onConfirm: () => onConfirmVoidAndRefund(),
		});
	};

	const voidEstimate = () => {
		const {
			invoiceId,
			invoiceNumber,
			isEstimate,
			invoiceVersion,
			totals: { appliedPayments },
		} = invoiceState;

		const onConfirmVoidInvoice = async () => {
			await voidInvoice(invoiceId, isEstimate);

			const invoiceData = await getInvoiceDetails(invoiceId);
			if (invoiceData) await handleInvoiceData(invoiceData);

			const paymentsData = await fetchPayments(invoiceId);
			if (paymentsData) setPaymentData(paymentsData);

			const refundInTransitData = await fetchRefundsInTransit(invoiceId);
			if (refundInTransitData) setRefundsInTransit(refundInTransitData);
		};

		if (
			nonrkpayDetailPrepayEnhancementsEnabled &&
			isEstimate &&
			invoiceVersion === 3 &&
			appliedPayments > 0 &&
			availableFunds > 0
		) {
			return voidAndRefundEstimate();
		}

		confirmationModal.current.openModal({
			title: `${lang.t("Confirm")} ${lang.t("Void")}`,
			message: (
				<span>
					{lang.t("Are you sure you want to void")}&nbsp;
					{lang.t(isEstimate ? "Estimate" : "Invoice").toLowerCase()} {invoiceNumber}?
					<br />
					<br />
					{lang.t("This action cannot be undone_")}
				</span>
			),
			cancelButton: lang.t("Cancel"),
			confirmButton: `${lang.t("Void")} ${lang.t(isEstimate ? "Estimate" : "Invoice")}`,
			onConfirm: () => onConfirmVoidInvoice(),
		});

		return null;
	};

	/**
	 * Groups job line items by the JobEventId. If the JobEventId and JobAssignmentId match the line item is the main job event
	 * @param {Array} item The specified line item
	 * @returns {Boolean} Determines if the line item is the main job event
	 */
	const isFirstItemForJob = item => {
		const { lineItems } = invoiceState;
		const assignmentIndex = lineItems.findIndex(
			i => i.JobAssignmentId === item.JobAssignmentId,
		);
		const firstEventIndex = lineItems.findIndex(i => i.JobEventId === item.JobEventId);
		return assignmentIndex === firstEventIndex;
	};

	const isAnyLineItemFinalizedForJobEvent = item => {
		const { lineItems } = invoiceState;

		return lineItems.some(lineItem =>
			lineItem.JobEventId === item.JobEventId && lineItem.Finalized
		)
	}

	const onClickFinalizeEstimate = async () => {
		const currentInvoice = buildInvoiceObject(true);

		let confirmationModalObject = {
			title: lang.t("Finalize Agency Estimate"),
			message: `${lang.t("Finalize estimate modal message")}`,
			confirmButton: lang.t("Finalize"),
			cancelButton: lang.t("Cancel"),
			onConfirm: () => onConfirmFinalizeEstimate(),
		};

		if (originalInvoice && !isEqual(originalInvoice, currentInvoice)) {
			confirmationModalObject = {
				title: lang.t("Save Changes"),
				message: (
					<span>
						{lang.t("save and finalize estimate body")}
						<br />
						<br />
						{lang.t("Finalize estimate modal message")}
					</span>
				),
				confirmButton: lang.t("Save and Finalize"),
				cancelButton: lang.t("Cancel"),
				onConfirm: () => handleSubmit(false, false, () => onConfirmFinalizeEstimate()),
			};
		}

		confirmationModal.current.openModal(confirmationModalObject);
	};

	const onConfirmFinalizeEstimate = async () => {
		const { invoiceId } = invoiceState;

		const invoiceData = await finalizeEstimate(invoiceId);

		if (invoiceData === null) return;

		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_INVOICE_PROPERTY_DATA,
			payload: { property: "estimateFinalized", value: true },
		});

		utils.notify({
			type: "success",
			message: lang.t("Finalized"),
			timeOut: 2000,
		});

		await startGenerateInvoiceFromEstimateFlow();
	};

	const startGenerateInvoiceFromEstimateFlow = async () => {
		const { invoiceId } = invoiceState;

		const validationResult = await verifyEstimateInvoiceable(invoiceId);

		if (!validationResult) return;

		if (!validationResult.Valid) {
			handleEstimateInvoiceableValidationErrors(validationResult.Errors);
			return;
		}

		if (
			validationResult.EstimateItemsMissingTimecard != null &&
			validationResult.EstimateItemsMissingTimecard.length > 0
		) {
			// We need to add the key TimeCard null since the MissingTimeCardModal filters item with TimeCard null
			// JobStartTime parsed since CORE creates a new Date object with the local timezone
			const itemsMissingTimecard = validationResult.EstimateItemsMissingTimecard.map(
				item => ({
					...item,
					TimeCard: null,
					JobStartTime: utils.buildUtcStringFromLocalParsedDate(item.JobStartTime),
				}),
			);

			setMissingTimecardModal({
				show: true,
				items: itemsMissingTimecard,
				creatingInvoiceFromEstimate: true,
			});
			return;
		}

		setShowGenerateEstimateInvoiceModal(true);
	};

	const onConfirmGenerateEstimateInvoiceModal = async dueDate => {
		const { invoiceId } = invoiceState;
		const parsedDueDate = new Date(dueDate);

		const data = await generateInvoiceFromEstimate(invoiceId, parsedDueDate);

		setShowGenerateEstimateInvoiceModal(false);

		if (data == null) return;

		const invoiceData = {
			...data,
			IssueDate: utils.normalizeDateToMidnight(data.IssueDate),
			DueDate: utils.normalizeDateToMidnight(data.DueDate),
		};

		transformToInvoice(invoiceData);
	};

	const restoreDefaultStates = () => {
		// Set to default value:
		setInternalNotes("");
		setShowInternalNotes(false);
		setAvailableFunds(0);
		setPaymentData([]);
		setRefundsInTransit([]);
		setPaymentHistory([]);
		setLineItemUpdates([]);
		setDeletingOfficerViewJob(undefined);
		setInvoiceConflicts([]);
		setSelectedAttachment({});
		setSelectedNote({});
		setAttachments(0);
		setNotes(0);
		setCurrentTimeCardItem(undefined);
		setJobActivityLogModalLineItem(undefined);
	};

	const transformToInvoice = async invoiceData => {
		const { EstimateId, EstimateNumber, Id } = invoiceData;

		restoreDefaultStates();

		await handleInvoiceData(invoiceData, true);

		const paymentsData = await fetchPayments(Id);
		if (paymentsData) setPaymentData(paymentsData);

		determineInvoiceDisclaimer();
		setShouldPreventReinitialization(true);

		router.push(`/payments/manualinvoice?id=${Id}`);

		confirmationModal.current.openModal({
			title: lang.t("Invoice Created"),
			message: `${lang.t("dynamic.navigationEstimateInvoiceModal", {
				estimateNumber: EstimateNumber,
			})}`,
			cancelButton: lang.t("Return to Estimate"),
			onCancel: () => onReturnToEstimate(EstimateId),
			confirmButton: lang.t("Edit Invoice"),
			onConfirm: () => confirmationModal.current.onExited(),
		});
	};

	const onReturnToEstimate = estimateId => {
		router.push(`/payments/manualinvoice?estimate=true&id=${estimateId}`);
	};

	const handleEstimateInvoiceableValidationErrors = errors => {
		const { typeId } = invoiceState;

		if (typeId === V3_INVOICE_TYPE_ID.AGENCY) {
			errors.forEach(e => {
				if (e.ErrorMessage) {
					utils.notify({
						type: "warning",
						message: e.ErrorMessage,
						title: "Warning",
					});
				}
			});

			if (isOnlyNoJobAssignmentError(errors)) handleNoJobAssignmentError();
		}

		if (isOnlyNoJobAssignmentErrorForOfficer(errors)) handleNoJobAssignmentError();
	};

	const isOnlyNoJobAssignmentError = errors =>
		errors.length === 1 &&
		errors.some(
			e =>
				e.ErrorCode ===
				NONRKPAY_INVOICE_ESTIMATES_INVOICEABLE_ERROR_CODES.ESTIMATE_DOES_NOT_HAVE_ANY_JOBS_ASSIGNED,
		);

	const isOnlyNoJobAssignmentErrorForOfficer = errors =>
		errors.length === 2 &&
		errors.some(
			e =>
				e.ErrorCode ===
				NONRKPAY_INVOICE_ESTIMATES_INVOICEABLE_ERROR_CODES.ESTIMATE_DOES_NOT_HAVE_ANY_JOBS_ASSIGNED,
		) &&
		errors.some(
			e =>
				e.ErrorCode ===
				NONRKPAY_INVOICE_ESTIMATES_INVOICEABLE_ERROR_CODES.ESTIMATE_IS_OFFICER,
		);

	const handleNoJobAssignmentError = () => {
		const {
			totals: { balance },
		} = invoiceState;

		if (balance > 0 || (balance === 0 && availableFunds === 0)) {
			openArchiveEstimateConfirmationModal();
		} else {
			setShowRefundNonRKPayInvoiceEstimateModal(true);
		}
	};

	const openArchiveEstimateConfirmationModal = () => {
		const { invoiceId } = invoiceState;

		confirmationModal.current.openModal({
			title: lang.t("Archive Estimate"),
			message: `${lang.t("There are no further actions that can be made on this estimate.")}
				${lang.t("Would you like to archive this estimate?")}`,
			confirmButton: lang.t("Yes, Archive Estimate"),
			cancelButton: lang.t("Cancel"),
			onConfirm: () => archiveEstimate(invoiceId),
		});
	};

	// Specific endpoint to archive ONLY estimates
	const archiveEstimate = async estimateId => {
		try {
			setSavingInvoice(true);
			await NonRKPayInvoiceEstimatesService.archiveEstimate(estimateId);
			dispatchInvoice({
				type: NONRKPAYINVOICE_ACTIONS.SET_INVOICE_PROPERTY_DATA,
				payload: { property: "archived", value: true },
			});
			utils.notify({
				type: "success",
				message: lang.t("Archived"),
				timeOut: 2000,
			});
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error archiving estimate"),
				timeOut: 2000,
			});
		} finally {
			setSavingInvoice(false);
		}
	};

	const unarchiveEstimate = async estimateId => {
		try {
			setSavingInvoice(true);
			await NonRKPayInvoiceEstimatesService.unarchiveEstimate(estimateId);
			dispatchInvoice({
				type: NONRKPAYINVOICE_ACTIONS.SET_INVOICE_PROPERTY_DATA,
				payload: { property: "archived", value: false },
			});
			utils.notify({
				type: "success",
				message: lang.t("Unarchived"),
				timeOut: 2000,
			});
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error unarchiving estimate"),
				timeOut: 2000,
			});
		} finally {
			setSavingInvoice(false);
		}
	};

	const confirmArchiveEstimateModal = id => {
		confirmationModal.current.openModal({
			title: `${lang.t("Archive Estimate")}`,
			message: <span>{lang.t("ArchiveEstimateText_")}</span>,
			cancelButton: lang.t("Cancel"),
			confirmButton: `${lang.t("Archive")}`,
			onConfirm: () => archiveEstimate(id),
		});

		return null;
	};

	const handleArchiveNonRKPayInvoice = (id, archived) => {
		const { isEstimate } = invoiceState;

		if (isEstimate) {
			if (archived) {
				unarchiveEstimate(id);
			} else {
				confirmArchiveEstimateModal(id);
			}
		} else {
			markArchive(id, archived);
		}
	};

	// Specific endpoint to refund only estimates.
	const handleRefundEstimate = async estimateId => {
		const { invoiceVersion, isEstimate, voided } = invoiceState;
		try {
			const { data } = await NonRKPayInvoiceEstimatesService.refundEstimate(estimateId);
			if (!data || data.Error) {
				utils.notify({
					type: "error",
					message: lang.t("Error refunding estimate"),
					timeOut: 2000,
				});
				return;
			}

			// If the estimate is version 2, we need to archive it after a successful refund
			// since version 2 (manual payments) will not automatically archive after a refund like version 3 does
			if (isEstimate && invoiceVersion === 2 && !voided) {
				await archiveEstimate(estimateId);
			}
		} catch (error) {
			const errorMessage = error?.response?.data?.Message;
			utils.notify({
				type: "error",
				message: errorMessage || lang.t("Error refunding estimate"),
				timeOut: 2000,
			});
			return;
		}

		const estimateData = await getInvoiceDetails(estimateId);
		if (estimateData) await handleInvoiceData(estimateData);

		const paymentsData = await fetchPayments(estimateId);
		if (paymentsData) setPaymentData(paymentsData);

		const refundInTransitData = await fetchRefundsInTransit(estimateId);
		if (refundInTransitData) setRefundsInTransit(refundInTransitData);

		if (nonrkpayDetailPrepayEnhancementsEnabled) {
			const availableFundsData = await fetchAvailableFunds(query.id);
			if (typeof availableFundsData === "number" && !Number.isNaN(availableFundsData)) {
				setAvailableFunds(availableFundsData);
			}
		}

		utils.notify({
			type: "success",
			message: lang.t("Estimate Refunded"),
			timeOut: 2000,
		});
	};

	const verifyEstimateInvoiceable = async estimateId => {
		try {
			setVerifyingEstimateInvoiceable(true);
			const { data } =
				await NonRKPayInvoiceEstimatesService.getEstimateInvoiceable(estimateId);
			return data;
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error getting Estimate Invoiceable"),
				title: "Error",
			});
			return null;
		} finally {
			setVerifyingEstimateInvoiceable(false);
		}
	};

	const fetchAvailableFunds = async estimateId => {
		try {
			const { data } =
				await NonRKPayInvoiceEstimatesService.getEstimateAvailableFunds(estimateId);
			return data;
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error getting Available Funds"),
				title: "Error",
			});
			return 0;
		}
	};

	const fetchEstimateAssociatedInvoices = async estimateId => {
		try {
			setLoadingEstimateAssociatedInvoices(true);
			const { data } =
				await NonRKPayInvoiceEstimatesService.getAssociatedInvoices(estimateId);
			return data;
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error Getting Associated Invoices"),
				title: lang.t("Error"),
			});

			return [];
		} finally {
			setLoadingEstimateAssociatedInvoices(false);
		}
	};

	/** Converts the invoice into an estimate */
	const onClickConvertEstimateToInvoice = async () => {
		const { lineItems } = invoiceState;
		const estimateItems = [...lineItems];
		// Get all jobEventIds that we have line items for
		const jobEventIds = estimateItems
			.map(item => item.JobEventId)
			.filter((val, idx, self) => self.indexOf(val) === idx);

		// Get values for worked line items in the invoice
		try {
			const { data } = await InvoiceService.getNonRKPayLineItems(true, jobEventIds);
			// If no jobs have been worked and we attempt to convert to an invoice, we receive an error from the API
			// If items is an empty array, notify the user that none of the jobs in the estimate were worked,
			// so an invoice cannot be created
			if (data.length <= 0) {
				utils.notify({
					type: "warning",
					message: lang.t(
						"No jobs from the estimate were worked, so an invoice cannot be created from this estimate",
					),
					timeOut: 5000,
				});
				return;
			}

			if (data.some(({ TimeCard }) => TimeCard === null)) {
				dispatchInvoice({ type: NONRKPAYINVOICE_ACTIONS.CLEAR_LINE_ITEMS });
				setMissingTimecardModal({ show: true, items: data });
			} else {
				// When converting an estimate to an invoice, all line should be overwritten with correct, up-to-date values
				// We also need to reset the invoiceState.lineFeeToggler
				overrideLineItemsWithData(filterEstimateLineItemsFees(estimateItems, data));
				dispatchInvoice({
					type: NONRKPAYINVOICE_ACTIONS.SET_INVOICE_PROPERTY_DATA,
					payload: { property: "showDelete", value: "" },
				});
				setForceShowConvertEstimateModal(true);
			}
		} catch (error) {
			utils.notify({
				type: "error",
				message: "Unable to convert estimate to invoice. Please try again.",
				timeOut: 2000,
			});
		}
	};

	/**
	 * Filter estimates fees with job items fees except for coordination fees in case the job doesn't have a coordination fee.
	 * @param {Array} estimateLineItems The estimate line items
	 * * @param {Array} jobLineItems The joba line items
	 * @returns {Array} The final line items
	 */
	const filterEstimateLineItemsFees = (estimateLineItems, jobLineItems) => {
		const newJobLineItems = jobLineItems.map(item => {
			const hasCoordFee = item.Fees.some(fee => fee.NonRKPayInvoiceFeeTypeId === 1);
			if (hasCoordFee) {
				return item;
			}
			const estimateLineItem = estimateLineItems.find(
				estimateItem => estimateItem.JobId === item.JobId,
			);
			if (estimateLineItem) {
				const estimateCoordFee = estimateLineItem.Fees.find(
					fee => fee.NonRKPayInvoiceFeeTypeId === 1,
				);
				if (estimateCoordFee) {
					return {
						...item,
						Fees: [...item.Fees, estimateCoordFee],
					};
				}
			}
			return item;
		});
		return newJobLineItems;
	};

	/**
	 * Converts the invoice estimate into a payable invoice
	 * @param {String} dueDate The date the invoice payment is due
	 */
	const onConfirmConvertEstimateToInvoice = dueDate => {
		let { invoiceNumber } = invoiceState;
		if (/(E|I)-\d{6}-\d{1,}/gi.test(invoiceNumber)) {
			// Change the E to an I to indicate an Invoice
			invoiceNumber = invoiceNumber.replace(/E/gi, "I");
			// Update the second part of the auto-generated invoice # to match today's date (mmddyy format)
			const issued = new Date().toLocaleString("en-US", {
				timeZone: TimeZoneId,
				month: "2-digit",
				day: "2-digit",
				year: "2-digit",
			});
			invoiceNumber = invoiceNumber.replace(/-\d{6}-/gi, `-${issued.replace(/\//g, "")}-`);
		}

		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.CONVERT_TO_INVOICE,
			payload: {
				invoiceNumber,
				dueDate,
				issueDate: utils.formatDate(
					new Date(),
					utils.isDesktopSafari || utils.isIE ? "en-US" : undefined,
					TimeZoneId,
					"2-digit",
				),
			},
		});
		setConvertingEstimateToInvoice(true);
	};

	/**
	 * Toggles the archived status of the invoice
	 * @param {Number} id The unique id of the invoice
	 * @param {Boolean} archived Determines if the invoices archived status
	 */
	const markArchive = async (id, archived) => {
		// This function marks the invoice as archive and vice versa and then updates the state every time the Archive button is clicked under Invoice actions.
		if (!archived) {
			try {
				await InvoiceService.archiveInvoice(id);
				dispatchInvoice({
					type: NONRKPAYINVOICE_ACTIONS.SET_INVOICE_PROPERTY_DATA,
					payload: { property: "archived", value: true },
				});
				utils.notify({
					type: "success",
					message: lang.t("Archived"),
					timeOut: 2000,
				});
			} catch (error) {
				utils.notify({
					type: "error",
					message: lang.t("Unable to archive this invoice"),
					timeOut: 2000,
				});
			}
		} else {
			try {
				await InvoiceService.unarchiveInvoice(id);
				dispatchInvoice({
					type: NONRKPAYINVOICE_ACTIONS.SET_INVOICE_PROPERTY_DATA,
					payload: { property: "archived", value: false },
				});
				utils.notify({
					type: "success",
					message: lang.t("Unarchived"),
					timeOut: 2000,
				});
			} catch (error) {
				utils.notify({
					type: "error",
					message: lang.t("Unable to unarchive this invoice"),
					timeOut: 2000,
				});
			}
		}
	};

	/** Displays a confirmation modal prompting the user to confirm the deletion of the invoice */
	const deleteInvoice = () => {
		const { invoiceId, isEstimate } = invoiceState;

		const onConfirmDeleteInvoice = async () => {
			try {
				await InvoiceService.deleteManualInvoice(invoiceId);
				returnToList();
			} catch (error) {
				utils.notify({
					type: "error",
					message: `${lang.t("Error deleting")} ${lang.t(isEstimate ? "Estimate" : "Invoice").toLowerCase()}`,
					timeOut: 2000,
				});
			}
		};

		let message = lang.t("dynamic.Are you sure you want to delete this", {
			subject: lang.t(isEstimate ? "Estimate" : "Invoice").toLowerCase(),
		});
		message += ` ${lang.t("This action cannot be undone_")}`;
		confirmationModal.current.openModal({
			title: lang.t("Confirm"),
			message,
			cancelButton: lang.t("Cancel"),
			confirmButton: `${lang.t("Delete")} ${lang.t(isEstimate ? "Estimate" : "Invoice")}`,
			onConfirm: () => onConfirmDeleteInvoice(),
		});
	};

	const confirmSaveAndApplyPayment = invoiceId => {
		const currentInvoice = buildInvoiceObject(true);

		if (!isEqual(originalInvoice, currentInvoice)) {
			confirmationModal.current.openModal({
				title: lang.t("Save Changes"),
				message: `${lang.t("You have unsaved changes_")} ${lang.t("Would you like to save before applying payment_")}`,
				confirmButton: lang.t("Save and Apply Payment"),
				onConfirm: () =>
					handleSubmit(false, false, () => {
						setForceApplyPaymentModal({ show: true, invoiceId });
					}),
			});
		} else {
			applyPaymentsModal.current.openModal(invoiceId);
		}
	};

	const confirmSavePrint = () => {
		const { invoiceVersion, isEstimate, voided, finalized } = invoiceState;

		const currentInvoice = buildInvoiceObject(true);

		if (!isEqual(originalInvoice, currentInvoice)) {
			confirmationModal.current.openModal({
				title: lang.t("Save Changes"),
				message: `${lang.t("You have unsaved changes_")} ${lang.t("Would you like to save before printing_")}`,
				confirmButton: lang.t("Save and Print"),
				onConfirm: () => handleSubmit(false, false, () => window.print()),
			});
		} else if (invoiceVersion === 3 && !isEstimate && !finalized && !voided) {
			confirmationModal.current.openModal({
				title: lang.t("Nonrkpay invoice print title"),
				message: <div>{lang.t("Nonrkpay invoice print message")}</div>,
				confirmButton: lang.t("Continue"),
				onConfirm: () =>
					setTimeout(() => {
						window.print();
						clearTimeout();
					}, 100),
			});
		} else {
			window.print();
		}
	};

	const downloadInvoicePDF = async () => {
		const { invoiceVersion, invoiceId, invoiceNumber, isEstimate, finalized, voided } =
			invoiceState;

		const currentInvoice = buildInvoiceObject(true);

		const downloadInvoice = async () => {
			try {
				setDownloadingInvoice(true);
				const { data } = await InvoiceService.downloadManualInvoicePDF(invoiceId);
				utils.downloadFromBlobResponse(
					data,
					isEstimate ? `estimate_${invoiceNumber}.pdf` : `invoice_${invoiceNumber}.pdf`,
				);
				utils.notify({
					type: "success",
					message: `${isEstimate ? "Estimate" : "Invoice"} downloaded correctly`,
					timeOut: 1500,
				});
			} catch (e) {
				utils.notify({
					type: "error",
					message: `Unable to download ${isEstimate ? "Estimate" : "Invoice"}`,
					timeOut: 2000,
				});
			} finally {
				setDownloadingInvoice(false);
			}
		};

		if (!isEqual(originalInvoice, currentInvoice)) {
			confirmationModal.current.openModal({
				title: lang.t("Save Changes"),
				message: `${lang.t("You have unsaved changes_")} ${lang.t("Would you like to save before downloading_")}`,
				confirmButton: lang.t("Save and Download"),
				onConfirm: () => handleSubmit(false, true, () => downloadInvoice()),
			});
		} else if (invoiceVersion === 3 && !isEstimate && !finalized && !voided) {
			confirmationModal.current.openModal({
				title: lang.t("Nonrkpay invoice download pdf title"),
				message: <div>{lang.t("Nonrkpay invoice download pdf message")}</div>,
				confirmButton: lang.t("Download"),
				onConfirm: () => downloadInvoice(),
			});
		} else {
			await downloadInvoice();
		}
	};

	/**
	 * @param {Boolean} isComparing Indicates whether we are building an invoice object for comparison purposes, in which case certain properties are omitted
	 * @returns An invoice object that can be used either to save/update an invoice or to compare one invoice object against another
	 */
	const buildInvoiceObject = (isComparing = false) => {
		const {
			invoiceId,
			isEstimate,
			invoiceNumber,
			invoiceDisclaimer,
			sentDateTimeUTC,
			billTo: {
				streetAddress: StreetAddress,
				city: City,
				stateId: StateId,
				stateName: StateName,
				stateAbbreviation: StateAbbreviation,
				zip: Zip,
				phone: ClientPhoneNumber,
				email: ClientEmailAddress,
				contact: ClientContactName,
			},
			from: {
				name: OrganizationName,
				address: OrganizationAddress,
				phone: OrganizationPhoneNumber,
				email: OrganizationEmailAddress,
				contact: OrganizationContactName,
			},
			lineItems,
			totals: { additionalFees: Fees },
			notesToClient,
			prePay,
		} = invoiceState;

		const { value: ClientId, label: ClientName } = selectedClient;

		// Destructuring these separately so that they can be modified as needed if the user is on Safari or IE
		let { issueDate, dueDate } = invoiceState;
		// Clean up the issue date and due date strings to prevent any unseen characters being inserted on IE11;
		issueDate = utils.fixIELocaleString(issueDate);
		dueDate = utils.fixIELocaleString(dueDate);

		if (utils.isDesktopSafari || utils.isIE) {
			issueDate = utils.fixIELocaleString(utils.formatDate(new Date(issueDate)));
			dueDate = utils.fixIELocaleString(utils.formatDate(new Date(dueDate)));
		}
		issueDate = `${issueDate}${isComparing || (!utils.isDesktopSafari && !utils.isIE) ? "T" : " "}00:00:00`;
		dueDate = `${dueDate}${isComparing || (!utils.isDesktopSafari && !utils.isIE) ? "T" : " "}00:00:00`;

		const Items = lineItems.map(item => ({
			...item,
			Rate: Number(item.Rate),
			Fees: item.Fees.map(fee => ({ ...fee, Total: Number(fee.Total) })).sort(
				(a, b) => a.Id - b.Id,
			),
		}));

		let invoiceObject = {};

		invoiceObject = {
			IsEstimate: isEstimate,
			IssueDate: issueDate,
			DueDate: dueDate,
			SentDateTimeUTC: sentDateTimeUTC,
			ClientId,
			ClientName,
			ClientPhoneNumber,
			ClientEmailAddress,
			ClientContactName,
			OrganizationName,
			OrganizationPhoneNumber,
			OrganizationEmailAddress,
			OrganizationContactName,
			OrganizationAddress,
			Fees: Fees.sort((a, b) => a.Id - b.Id),
			Items,
			Comments: internalNotes,
			NotesToClient: notesToClient,
			InvoiceDisclaimer: invoiceDisclaimer,
			ClientLocationAddress: {
				StreetAddress,
				City,
				StateId,
				StateName,
				StateAbbreviation,
				Zip,
			},
			RequirePrepayment: prePay,
		};

		if (invoiceNumber !== "") invoiceObject.InvoiceNumber = invoiceNumber;
		if (isEstimate) {
			invoiceObject.DueDate = issueDate;
			invoiceObject.Items = invoiceObject.Items.map(item => {
				// If the JobAssignmentId value is something that was generated by the front-end, no assignment actually exists
				// Set the JobAssignmentId back to null for submission
				// OfficerName is changed back to null conditionally as well
				if (item.JobAssignmentId.toString().includes("_")) {
					return {
						...item,
						JobAssignmentId: null,
						OfficerName: item.OfficerName === "TBD" ? null : item.OfficerName,
					};
				}
				return item;
			});
		}
		if (invoiceId) invoiceObject.Id = invoiceId;

		// If creating new, original is null
		if (isComparing && originalInvoice) {
			return {
				...originalInvoice,
				...invoiceObject,
				ClientLocationAddress: {
					...originalInvoice.ClientLocationAddress,
					...invoiceObject.ClientLocationAddress,
				},
			};
		}

		return invoiceObject;
	};

	const toggleOfficerView = () => {
		dispatchInvoice({ type: NONRKPAYINVOICE_ACTIONS.TOGGLE_OFFICER_VIEW });
	};

	const openDeleteJobConfirmation = jobEventId => {
		setDeletingOfficerViewJob(jobEventId);
	};

	/**
	 * Calculates an officer's total pay across all invoiced jobs that they worked.
	 * @param {Object} officer An object containing an officer's name and RollKall ID. If they officer is not on RollKall, then `OfficerId = undefined`
	 * @param {String} officer.OfficerName
	 * @param {Number} officer.OfficerId
	 * @returns {Number} The total amount to be paid to an officer for all invoiced jobs that they worked on
	 */
	const getOfficerTotalAcrossJobs = officer => {
		const { lineItems } = invoiceState;
		const officerTotals = lineItems
			.filter(i => i.OfficerName === officer.OfficerName && i.OfficerId === officer.OfficerId)
			.map(i => i.OfficerPayAmount);
		return officerTotals.reduce((total, curr) => total + curr, 0);
	};

	const onEditTimeCard = async (positionId, _, clockInTimeModal, clockOutTimeModal, note) => {
		const startDate = (
			currentTimeCardItem.Id
				? currentTimeCardItem.ClockInTime
				: currentTimeCardItem.JobStartTime
		).split("T")[0];
		const [ClockInTime, ClockOutTime] = utils.combineDateAndTimecardTimes(
			startDate,
			currentTimeCardItem.__computedData.JobTimeZoneId,
			[clockInTimeModal, clockOutTimeModal],
		);
		const timecard = {
			JobId: positionId,
			Reason: note,
			JobAssignmentId: currentTimeCardItem.JobAssignmentId,
			AssignedOfficerId: currentTimeCardItem.AssignedOfficerId,
			ClockInTime,
			ClockOutTime,
		};

		if (currentTimeCardItem.Id) {
			timecard.Id = currentTimeCardItem.Id;
		}

		try {
			await (currentTimeCardItem.Id
				? TimecardService.updateTimecard(timecard)
				: TimecardService.createTimecard(timecard));

			setShowEditTimeCardForm(false);
			setCurrentTimeCardItem(null);
		} catch (error) {
			utils.notify({
				type: "error",
				message: "Error updating timecard information",
				timeOut: 1500,
			});
		}
	};

	const approveNonRKPayInvoice = async invoiceId => {
		try {
			await InvoiceService.approveNonRKPayInvoice({ InvoicesIds: [invoiceId] });
			utils.notify({
				type: "success",
				message: lang.t("Invoice successfully approved"),
				timeOut: 2000,
			});

			const invoiceData = await getInvoiceDetails(invoiceId);
			if (invoiceData) await handleInvoiceData(invoiceData);
		} catch ({ response: { data } }) {
			utils.notify({
				type: "error",
				message: data?.Message || lang.t("Error approving invoice"),
				timeOut: 1500,
			});
		}
	};

	const moveNonRKPayInvoiceToPendingAgencyReview = async invoiceId => {
		try {
			setSavingInvoice(true);
			await NonRKPayInvoiceService.unfinalize(invoiceId);
			utils.notify({
				type: "success",
				message: lang.t("Invoice successfully moved to pending agency review"),
				timeOut: 2000,
			});

			const invoiceData = await getInvoiceDetails(invoiceId);
			if (invoiceData) await handleInvoiceData(invoiceData);
		} catch ({ response: { data } }) {
			utils.notify({
				type: "error",
				message: data?.Message || lang.t("Error moving invoice to pending agency review"),
				timeOut: 1500,
			});
		} finally {
			setSavingInvoice(false);
		}
	};

	const recalculateNonRKPayInvoice = async invoiceId => {
		try {
			await InvoiceService.recalculateNonRKPayInvoice(invoiceId);
			utils.notify({
				type: "success",
				message: lang.t("Invoice successfully recalculated"),
				timeOut: 2000,
			});

			const invoiceData = await getInvoiceDetails(invoiceId);
			if (invoiceData) await handleInvoiceData(invoiceData);
		} catch (error) {
			utils.notify({
				type: "error",
				message: lang.t("Error recalculating invoice"),
				timeOut: 1500,
			});
		}
	};

	const changeNonRKPayInvoiceStatus = async (invoiceId, status) => {
		try {
			await InvoiceService.updateNonRKPayInvoiceStatus(invoiceId, status);
			utils.notify({
				type: "success",
				message: lang.t("Invoice status successfully updated"),
				timeOut: 2000,
			});

			const invoiceData = await getInvoiceDetails(invoiceId);
			if (invoiceData) await handleInvoiceData(invoiceData);
		} catch ({ response: { data } }) {
			utils.notify({
				type: "error",
				message: data?.Message || lang.t("Error updating invoice status"),
				timeOut: 1500,
			});
		}
	};

	const handleOnSaveInternalNotes = async () => {
		const { invoiceId } = invoiceState;

		try {
			const internalNotesData = await fetchInternalNotesForNonRKPayInvoice(invoiceId);
			if (internalNotesData.Message) {
				setInternalNotes(internalNotesData.Message);
				setShowInternalNotes(true);
				setOriginalInvoice({
					...originalInvoice,
					Comments: internalNotesData.Message,
				});
			} else {
				setShowInternalNotes(false);
			}
		} catch (e) {
			utils.notify({
				type: "error",
				message: lang.t("Error getting invoice internal notes_"),
				title: "Error",
			});
		}
	};

	const checkExcludeOfficerRateLineItems = () => {
		const { lineItems } = invoiceState;
		const allItemsExcludeOfficerRate = lineItems.every(item => item.ExcludeOfficerRate);
		setExcludeOfficerRate(allItemsExcludeOfficerRate);
	};

	const onClickEditInvoiceLineItemTimeCard = lineItem => async () => {
		try {
			const { data: timecard } = await TimecardService.getTimeCardByJobIdAndOfficerId(
				lineItem.JobId,
				lineItem.OfficerId,
			);
			const timeZoneId = lineItem.JobTimeZoneId ?? user.TimeZoneId;
			if (timecard) {
				const useMilitaryTime = user.UserPreferences === "useMilitaryTime";
				const formattedClockInTime = timecard?.ClockInTime
					? utils.formatTimeWithZero(timecard.ClockInTime, !useMilitaryTime, timeZoneId)
					: "";
				const formattedClockOutTime = timecard?.ClockOutTime
					? utils.formatTimeWithZero(timecard.ClockOutTime, !useMilitaryTime, timeZoneId)
					: "";

				// We need to evaluate if the ClockInTime is a string or an object since
				// the nexus client returns an object and the website returns a string.
				if (typeof timecard.ClockInTime === "object") {
					timecard.ClockInTime = timecard.ClockInTime.toISOString();
					timecard.ClockOutTime = timecard.ClockOutTime.toISOString();
				}

				setCurrentTimeCardItem({
					...timecard,
					__computedData: {
						ClockInTime: formattedClockInTime,
						ClockOutTime: formattedClockOutTime,
						JobTimeZoneId: timeZoneId,
					},
				});
				setShowEditTimeCardForm(true);
			} else {
				setCurrentTimeCardItem({
					JobId: lineItem.JobId,
					JobStartTime: lineItem.JobStartTime,
					JobAssignmentId: lineItem.JobAssignmentId,
					AssignedOfficerId: lineItem.OfficerId,
					__computedData: {
						JobTimeZoneId: timeZoneId,
					},
				});
				setShowEditTimeCardForm(true);
			}
		} catch (error) {
			/**
			 * Request can also fail if there
			 * is no job assignment on this
			 * invoice line item.
			 * */
			if (error) {
				utils.notify({
					type: "warning",
					message: "Unable to get timecard information",
					timeOut: 1500,
				});
			}
		}
	};

	const onClickViewJobActivityLogLineItem = lineItem => async () => {
		setJobActivityLogModalLineItem({
			OfficerClockIn: utils.formatDateTime(
				lineItem.CheckinDateTimeUTC,
				lineItem.JobTimeZoneId,
				user.UserPreferences === "useMilitaryTime",
			),
			OfficerClockOut: utils.formatDateTime(
				lineItem.CheckoutDateTimeUTC,
				lineItem.JobTimeZoneId,
				user.UserPreferences === "useMilitaryTime",
			),
			PositionId: lineItem.JobId,
			OfficerId: lineItem.OfficerId,
			JobEventTimeZoneId: lineItem.JobTimeZoneId,
			PositionTitle: lineItem.JobTitle,
		});

		setShowJobActivityLogModal(true);
	};

	const isLineItemTimeCardEditable = lineItem =>
		editTimecardAgencyInvoiceEnabled &&
		typeof lineItem.JobAssignmentId === "number" &&
		typeof lineItem.OfficerId === "number";

	const isAttachmentsVisible = lineItem =>
		timecardAttachmentsInvoiceV4Enabled &&
		(lineItem.Attachments || []).length > 0 &&
		typeof lineItem.JobAssignmentId === "number" &&
		typeof lineItem.OfficerId === "number";

	const isTimeCardNoteVisible = lineItem =>
		timeCardNotesModalEnabled &&
		notes > 0 &&
		lineItem.TimeCard != null &&
		typeof lineItem.JobAssignmentId === "number" &&
		typeof lineItem.OfficerId === "number";

	const handleShowDeleteChange = value => {
		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_INVOICE_PROPERTY_DATA,
			payload: { property: "showDelete", value },
		});
	};

	const hideInternalNotes = () => {
		setShowInternalNotes(false);
	};

	/** Retrieves manual invoicing fee types and predefined organization fees */
	const getCustomFeeData = () => {
		const promises = [];
		// eslint-disable-next-line no-promise-executor-return
		promises.push(
			new Promise(resolve =>
				InvoiceService.getManualInvoiceFeeTypes()
					.then(({ data }) => resolve(data))
					.catch(() => resolve([])),
			),
		);
		if (!user.isCoordinator()) {
			// eslint-disable-next-line no-promise-executor-return
			promises.push(
				new Promise(resolve =>
					GenericService.getVehicleTypes()
						.then(({ data }) => resolve(data))
						.catch(() => resolve([])),
				),
			);
			// eslint-disable-next-line no-promise-executor-return
			promises.push(
				new Promise(resolve =>
					JurisdictionFeeService.getAll()
						.then(({ data }) => resolve(data))
						.catch(() => resolve({})),
				),
			);
		}

		Promise.all(promises).then(([feeTypesData, vehicleTypesData, agencyFeePresetsData]) => {
			setFeeTypes(filterFeeTypesToUser(feeTypesData));
			setVehicleTypes(vehicleTypesData || {});
			setAgencyFeePresets(agencyFeePresetsData || {});
		});
	};

	/**
	 * Determine which Invoice disclaimer is going to be used to pre-filled the invoice.
	 * New invoices/estimates should be prefilled with the Agency Disclaimer or client disclaimer if they have one determined.
	 * * @param {Boolean} isChangingClient Boolean indicating if it's coming from handleClientChange
	 */
	const determineInvoiceDisclaimer = async (
		isChangingClient = false,
		client = { value: "", label: "" },
	) => {
		const {
			Organization: { InvoiceDisclaimer },
		} = user;

		if (query.id && !isChangingClient) return;

		let newInvoiceDisclaimer = InvoiceDisclaimer;

		if (client?.value) {
			const clientInvoiceDisclaimer = await getClientInvoiceDisclaimer(client.value);
			if (clientInvoiceDisclaimer) {
				newInvoiceDisclaimer = clientInvoiceDisclaimer;
			}
		}

		dispatchInvoice({
			type: NONRKPAYINVOICE_ACTIONS.SET_INVOICE_PROPERTY_DATA,
			payload: {
				property: "invoiceDisclaimer",
				value: newInvoiceDisclaimer,
			},
		});
	};

	const onConfirmCancelConvertEstimate = async () => {
		const { invoiceId } = invoiceState;

		setShowConvertEstimateModal(false);
		const invoiceData = await getInvoiceDetails(invoiceId);
		if (invoiceData) await handleInvoiceData(invoiceData);
	};

	const onCancelMissingTimecardModal = async () => {
		const { invoiceId, isEstimate } = invoiceState;

		if (missingTimecardModal.creatingInvoiceFromEstimate && isEstimate) {
			setMissingTimecardModal(undefined);
			return;
		}

		setMissingTimecardModal(undefined);
		if (invoiceId) {
			const invoiceData = await getInvoiceDetails(invoiceId);
			if (invoiceData) await handleInvoiceData(invoiceData);
		}
	};

	// The invoiceState.lineItems state is updated asynchronously by multiple API calls (getInvoiceDetails and getNonRKPayLineItems).
	// Originally, setLineItems was called in both functions, causing a race condition where the second API call
	// could overwrite the invoiceState.lineItems state before the first one had finished updating it. As a result, some data
	// from the first API call (getInvoiceDetails) was being lost.
	//
	// To resolve this, we introduced (newLineItemsToAdd and initialInvoiceLoadFinished) to temporarily store the result from the second
	// API call (getNonRKPayLineItems). We then used a useEffect to listen for changes to newLineItemsToAdd and initialInvoiceLoadFinished
	// state, and once both API calls have completed, we update the final invoiceState.lineItems state with the
	// combined data. This ensures that the state is updated only after both API calls have finished and avoids overwriting any data.
	const processNewLineItems = () => {
		const [...data] = newLineItemsToAdd;
		const workedJobs = query.estimate === "false";
		const sorted = { existing: [], new: [] };
		const areThereTimecardMissed = data.some(({ TimeCard }) => TimeCard === null);

		if (workedJobs && areThereTimecardMissed) {
			setMissingTimecardModal({
				show: true,
				items: data,
				addingLineItemsFromUri: query.clientId && query.jobs,
			});
		} else {
			data.forEach(item => {
				if (item.InvoiceNumber) sorted.existing.push(item);
				else sorted.new.push(item);
			});
			// Display existing estimates in modal
			setInvoiceConflicts(sorted.existing);
			setLineItemsData(sorted.new);
			setAddingLineItemsFromUri(true);
		}
		setNewLineItemsToAdd([]);
	};

	const initialize = async () => {
		if (query.id) {
			const invoiceData = await getInvoiceDetails(query.id);
			if (invoiceData) await handleInvoiceData(invoiceData, true);

			if (query.clientId && query.jobs) {
				const newJobIds = query.jobs.split(",");
				setLoadingLineItems(true);

				// The invoiceState.lineItems state is updated asynchronously by multiple API calls (getInvoiceDetails and getNonRKPayLineItems).
				// Originally, setLineItems was called in both functions, causing a race condition where the second API call
				// could overwrite the invoiceState.lineItems state before the first one had finished updating it. As a result, some data
				// from the first API call (getInvoiceDetails) was being lost.
				//
				// To resolve this, we introduced (newLineItemsToAdd and initialInvoiceLoadFinished) to temporarily store the result from the second
				// API call (getNonRKPayLineItems). We then used a useEffect to listen for changes to newLineItemsToAdd and initialInvoiceLoadFinished
				// state, and once both API calls have completed, we update the final invoiceState.lineItems state with the
				// combined data. This ensures that the state is updated only after both API calls have finished and avoids overwriting any data.
				const newLineItemsData = await fetchNonRKPayLineItemsForJobs(
					query.estimate === "false",
					newJobIds,
				);
				if (newLineItemsData) setNewLineItemsToAdd(newLineItemsData);
			}

			const internalNotesData = await fetchInternalNotesForNonRKPayInvoice(query.id);
			if (internalNotesData && internalNotesData.Message) {
				setInternalNotes(internalNotesData.Message);
				setShowInternalNotes(true);
			}

			if (invoiceData && invoiceData.IsEstimate && nonrkpayDetailPrepayEnhancementsEnabled) {
				const availableFundsData = await fetchAvailableFunds(query.id);
				if (availableFundsData) setAvailableFunds(availableFundsData);
			}

			const paymentsData = await fetchPayments(query.id);
			if (paymentsData) setPaymentData(paymentsData);

			const refundInTransitData = await fetchRefundsInTransit(query.id);
			if (refundInTransitData) setRefundsInTransit(refundInTransitData);

			if (
				invoiceData &&
				invoiceData.IsEstimate &&
				nonrkpayDetailPrepayEnhancementsEnabled
			) {
				const associatedInvoicesData = await fetchEstimateAssociatedInvoices(query.id);
				if (associatedInvoicesData) setAssociatedInvoices(associatedInvoicesData);
			}
		} else {
			if (query.clientId) {
				const jobIds = query.jobs.split(",");
				setLoadingLineItems(true);

				const workedJobs = query.estimate === "false";
				const nonRKPayLineItemsData = await fetchNonRKPayLineItemsForJobs(
					workedJobs,
					jobIds,
				);
				if (nonRKPayLineItemsData) addNewLineItem(nonRKPayLineItemsData, workedJobs);
			}

			dispatchInvoice({
				type: NONRKPAYINVOICE_ACTIONS.SET_INITIAL_INVOICE_INFO_FROM_USER,
				payload: {
					isEstimate: query.estimate === "true",
					invoiceVersion: Features.some(f => f.toLowerCase() === "invoicingv3") ? 3 : 2,
					user,
				},
			});
			setIsInvoicingV3(Features.some(f => f.toLowerCase() === "invoicingv3"));
		}
		determineInvoiceDisclaimer();
		if (!user.isSuperAdmin()) {
			await getCustomFeeData();
			const isEstimate = query.estimate === "true";
			const clientsData = await getClients(isEstimate)
			if (clientsData) await setClientsData(clientsData, isEstimate);
		}

		document.addEventListener("click", clickEventListener);
		setInitialized(true);
	};

	useEffect(() => {
		if (NonRKPayInvoicingEnabled) {
			initialize();
		} else {
			returnToList();
		}

		// Cleanup function to remove evenListener when component unmounts
		return () => {
			document.removeEventListener("click", clickEventListener);
		};
	}, []);

	useEffect(() => {
		router.setRouteLeaveHook(route, routerObject => invoiceChangeDiff(routerObject));
	}, [router, route, invoiceChangeDiff]);

	useEffect(() => {
		if (confirmedExit && pathnameToGo !== "") {
			router.push(pathnameToGo);
		}
	}, [confirmedExit, pathnameToGo]);

	useEffect(() => {
		const updateTotals = async () => {
			const draftTotals = await getNonRKPayInvoiceDraftTotals();
			if (draftTotals) handleInvoiceDraftTotals(draftTotals);
		};
		if (forceFetchInvoiceDraftTotals) {
			updateTotals();
			setForceFetchInvoiceDraftTotals(false);
		}
	}, [invoiceState.lineItems, customFee, forceFetchInvoiceDraftTotals]);

	useEffect(() => {
		if (forceCheckExcludeOfficerRate) {
			checkExcludeOfficerRateLineItems();
			setForceCheckExcludeOfficerRate(false);
		}
	}, [invoiceState.lineItems, forceCheckExcludeOfficerRate]);

	useEffect(() => {
		if (forceShowConvertEstimateModal) {
			setShowConvertEstimateModal(true);
			setForceShowConvertEstimateModal(false);
		}
	}, [invoiceState.lineItems, forceShowConvertEstimateModal]);

	useEffect(() => {
		if (convertingEstimateToInvoice) {
			handleSubmit(true);
			setConvertingEstimateToInvoice(false);
		}
	}, [convertingEstimateToInvoice]);

	useEffect(() => {
		if (initialInvoiceLoadFinished && newLineItemsToAdd.length > 0) {
			setInitialInvoiceLoadFinished(false);
			processNewLineItems();
		}
	}, [newLineItemsToAdd, initialInvoiceLoadFinished]);

	useEffect(() => {
		if (forceApplyPaymentModal.show) {
			applyPaymentsModal.current.openModal(forceApplyPaymentModal.invoiceId);
			setForceApplyPaymentModal({ show: false, invoiceId: null });
		}
	}, [forceApplyPaymentModal.show]);

	useEffect(() => {
		if (shouldPreventReinitialization) {
			setShouldPreventReinitialization(false);
			return;
		}

		restoreDefaultStates();
		setInitialized(false);
		initialize();
	}, [query.id]);

	return {
		invoiceState,
		paymentHistory,
		refundsInTransit,
		deletingOfficerViewJob,
		invoiceConflicts,
		excludeOfficerRate,
		selectedAttachment,
		selectedNote,
		attachments,
		notes,
		internalNotes,
		availableFunds,
		associatedInvoices,
		clientList,
		showConvertEstimateModal,
		showUpdateLineItemsModal,
		emailInvoiceModal,
		showInternalNotes,
		showEditTimeCardForm,
		showJobActivityLogModal,
		loadingLineItems,
		loadingInvoiceTotals,
		downloadingInvoice,
		savingInvoice,
		loadingInvoice,
		loadingEstimateAssociatedInvoices,
		confirmLineItemsRefresh,
		updateLineItems,
		onConfirmMissingTimecardModal,
		setAppliedPayments,
		handleInvoiceChange,
		handleFromChange,
		handleBillToChange,
		handleBillToStateChange,
		handleClientChange,
		handleClickAddJobs,
		handleRemoveLineItem,
		handlePositionChange,
		toggleLineFees,
		toggleNewLineFee,
		handleAddFeeClick,
		handleNewFeeChange,
		clearNewLineFeeName,
		handlePositionChangedOnBlur,
		handlePositionFeeChangedOnBlur,
		addNewLineFee,
		togglePaymentHistory,
		togglePrePay,
		toggleAttachmentsModal,
		toggleTimeCardNotesModal,
		toggleInternalNotesModal,
		handlePositionFeeChange,
		deletePositionFee,
		handleCustomFeeChange,
		createCustomFee,
		deleteCustomFee,
		toggleActionsDropdown,
		toggleRefundModal,
		voidEstimate,
		isFirstItemForJob,
		isAnyLineItemFinalizedForJobEvent,
		onClickConvertEstimateToInvoice,
		onConfirmConvertEstimateToInvoice,
		markArchive,
		deleteInvoice,
		confirmSaveAndApplyPayment,
		confirmSavePrint,
		downloadInvoicePDF,
		toggleOfficerView,
		openDeleteJobConfirmation,
		getOfficerTotalAcrossJobs,
		onEditTimeCard,
		handleOnSaveInternalNotes,
		onClickEditInvoiceLineItemTimeCard,
		onClickViewJobActivityLogLineItem,
		isLineItemTimeCardEditable,
		isAttachmentsVisible,
		isTimeCardNoteVisible,
		handleShowDeleteChange,
		hideInternalNotes,
		isInvoicingV3,
		selectedClient,
		missingTimecardModal,
		confirmationModal,
		applyPaymentsModal,
		showAttachmentsModal,
		showTimeCardNotesModal,
		showInternalNotesModal,
		currentTimeCardItem,
		jobActivityLogModalLineItem,
		showPaymentHistory,
		editTimecardAgencyInvoiceEnabled,
		setEmailInvoiceModal,
		setShowUpdateLineItemsModal,
		setDeletingOfficerViewJob,
		setInvoiceConflicts,
		feeTypes,
		customFee,
		addJobsModal,
		setShowEditTimeCardForm,
		setShowJobActivityLogModal,
		timecardAttachmentsInvoiceV4Enabled,
		refundingInvoice,
		handleSubmit,
		onConfirmCancelConvertEstimate,
		onCancelMissingTimecardModal,
		approveNonRKPayInvoice,
		changeNonRKPayInvoiceStatus,
		recalculateNonRKPayInvoice,
		getInvoiceDetails,
		handleInvoiceData,
		buildInvoiceObject,
		originalInvoice,
		showRefundNonRKPayInvoiceEstimateModal,
		setShowRefundNonRKPayInvoiceEstimateModal,
		verifyingEstimateInvoiceable,
		validateInvoice,
		handleRefundEstimate,
		isTimeCardNotesModalEnabled,
		nonrkpayDetailPrepayEnhancementsEnabled,
		onClickFinalizeEstimate,
		finalizingEstimate,
		newNonrkpayPrepayFlowEnabled,
		generatingInvoiceFromEstimate,
		showGenerateEstimateInvoiceModal,
		setShowGenerateEstimateInvoiceModal,
		onConfirmGenerateEstimateInvoiceModal,
		handleArchiveNonRKPayInvoice,
		startGenerateInvoiceFromEstimateFlow,
		initialized,
		allowVoidNonrkpayInvoicesV2Enabled,
		moveNonRKPayInvoiceToPendingAgencyReview,
		revertInvoiceToPendingAgencyReviewEnabled,
		toggleConnectedInvoicesModal,
		showConnectedInvoicesModal,
	};
};

export default useNonRKPayInvoiceDetailHook;
